const sru_data = {
    code: [
        '01427',
        '01322',
        '01283',
        '01185',
        '01031',
        '01265',
        '01053',
        '01451',
        '01289',
        '01344',
        '01262',
        '01142',
        '01354',
        '01160',
        '01313',
        '01419',
        '01281',
        '01249',
        '01043',
        '01376',
        '02691',
        '02340',
        '02168',
        '02722',
        '02064',
        '03185',
        '03101',
        '03098',
        '03190',
        '03321',
        '03013',
        '03310',
        '03095',
        '03023',
        '03236',
        '04112',
        '04143',
        '83150',
        '04242',
        '04152',
        '04197',
        '05061',
        '06088',
        '06027',
        '06123',
        '06157',
        '06033',
        '06149',
        '06065',
        '06114',
        '06075',
        '06054',
        '06159',
        '06147',
        '06032',
        '06122',
        '06064',
        '06011',
        '06046',
        '06069',
        '06084',
        '06095',
        '06090',
        '06108',
        '06118',
        '06130',
        '06029',
        '06030',
        '06079',
        '06085',
        '06083',
        '06104',
        '06012',
        '06136',
        '06004',
        '06155',
        '06161',
        '06152',
        '06018',
        '06044',
        '06105',
        '06112',
        '06148',
        '06038',
        '06048',
        '07102',
        '07281',
        '07319',
        '08105',
        '08409',
        '08328',
        '08480',
        '08491',
        '10387',
        '10333',
        '10081',
        '10362',
        '10343',
        '10297',
        '10325',
        '10321',
        '11069',
        '11397',
        '11429',
        '11262',
        '11266',
        '11106',
        '11379',
        '11170',
        '11202',
        '11116',
        '11145',
        '12202',
        '12176',
        '12133',
        '12174',
        '13027',
        '13066',
        '13045',
        '13018',
        '13036',
        '13010',
        '13083',
        '13076',
        '13055',
        '13001',
        '13056',
        '13005',
        '13103',
        '13047',
        '13028',
        '13117',
        '13054',
        '13063',
        '13071',
        '13041',
        '13002',
        '84089',
        '13026',
        '13077',
        '13039',
        '13015',
        '13014',
        '13007',
        '13081',
        '13106',
        '13075',
        '13110',
        '13069',
        '13019',
        '13040',
        '13050',
        '13043',
        '13051',
        '13037',
        '13112',
        '13086',
        '13092',
        '13078',
        '13113',
        '13032',
        '13104',
        '13035',
        '13119',
        '13105',
        '13042',
        '13022',
        '13070',
        '13016',
        '13060',
        '13053',
        '13098',
        '13030',
        '13091',
        '83120',
        '13107',
        '13080',
        '13033',
        '13085',
        '13021',
        '13114',
        '13073',
        '13087',
        '13084',
        '13044',
        '13074',
        '13088',
        '13023',
        '13082',
        '13048',
        '13046',
        '13062',
        '13031',
        '13059',
        '13118',
        '13072',
        '13004',
        '13108',
        '13097',
        '14118',
        '14327',
        '14341',
        '14437',
        '14488',
        '14167',
        '14098',
        '14076',
        '14271',
        '14181',
        '14301',
        '14101',
        '14738',
        '14068',
        '14366',
        '14431',
        '14654',
        '14371',
        '15014',
        '15012',
        '15267',
        '16102',
        '16167',
        '16089',
        '16090',
        '16015',
        '16374',
        '16113',
        '16358',
        '16291',
        '16154',
        '16166',
        '16078',
        '16287',
        '16061',
        '16138',
        '17415',
        '17086',
        '17299',
        '17449',
        '17168',
        '17146',
        '17300',
        '17028',
        '17274',
        '17200',
        '17291',
        '17094',
        '17142',
        '17264',
        '17414',
        '17407',
        '17010',
        '17306',
        '17421',
        '17333',
        '17452',
        '17461',
        '17380',
        '17021',
        '18033',
        '18205',
        '18141',
        '18213',
        '18267',
        '18050',
        '19031',
        '19123',
        '19229',
        '19274',
        '19005',
        '19153',
        '21054',
        '71073',
        '21231',
        '21166',
        '21617',
        '21171',
        '21515',
        '21278',
        '21355',
        '21540',
        '21390',
        '22113',
        '22168',
        '22343',
        '22198',
        '22211',
        '22194',
        '22093',
        '22186',
        '22258',
        '22054',
        '22278',
        '22187',
        '22215',
        '22360',
        '22106',
        '22251',
        '22055',
        '22176',
        '22389',
        '22171',
        '22081',
        '22203',
        '24322',
        '24053',
        '24138',
        '24557',
        '24312',
        '24102',
        '24026',
        '24037',
        '24340',
        '25388',
        '25031',
        '25580',
        '25539',
        '25284',
        '25057',
        '25367',
        '25463',
        '25547',
        '25228',
        '25048',
        '25304',
        '25056',
        '25527',
        '26198',
        '26362',
        '26281',
        '26058',
        '26252',
        '26057',
        '26064',
        '26088',
        '26313',
        '26124',
        '26197',
        '26037',
        '26084',
        '27105',
        '27090',
        '27229',
        '27602',
        '27299',
        '27507',
        '27681',
        '27016',
        '27213',
        '27448',
        '27562',
        '27375',
        '27701',
        '27275',
        '27022',
        '27469',
        '27528',
        '28085',
        '28218',
        '28229',
        '28220',
        '28209',
        '28227',
        '28110',
        '28070',
        '28134',
        '28404',
        '28348',
        '28359',
        '27230',
        '29232',
        '29051',
        '29020',
        '29170',
        '29216',
        '29019',
        '29075',
        '29189',
        '29212',
        '29235',
        '29069',
        '29061',
        '29011',
        '29039',
        '29241',
        '29293',
        '29151',
        '29199',
        '29254',
        '29207',
        '30028',
        '30202',
        '30141',
        '30007',
        '30243',
        '30294',
        '30132',
        '30284',
        '30259',
        '30223',
        '30305',
        '30333',
        '30123',
        '30189',
        '30258',
        '30156',
        '30155',
        '30169',
        '30047',
        '30125',
        '30075',
        '30206',
        '30082',
        '30211',
        '30060',
        '30128',
        '31118',
        '31079',
        '31395',
        '31187',
        '31547',
        '31203',
        '31499',
        '31433',
        '31165',
        '31248',
        '31458',
        '31421',
        '31460',
        '31555',
        '31149',
        '31557',
        '31069',
        '31157',
        '31044',
        '31506',
        '31561',
        '31488',
        '31116',
        '31588',
        '31022',
        '31282',
        '31417',
        '31150',
        '31056',
        '31490',
        '31032',
        '31467',
        '31445',
        '31351',
        '31091',
        '31182',
        '31230',
        '31389',
        '31113',
        '31446',
        '31169',
        '31035',
        '31254',
        '31424',
        '31291',
        '31526',
        '31188',
        '31410',
        '31117',
        '33243',
        '33138',
        '33207',
        '33393',
        '33539',
        '33063',
        '33281',
        '33318',
        '33522',
        '33550',
        '33449',
        '33039',
        '33119',
        '33192',
        '33249',
        '33162',
        '33069',
        '33075',
        '33167',
        '33003',
        '33056',
        '33200',
        '33519',
        '33312',
        '33013',
        '33096',
        '33032',
        '33273',
        '33376',
        '33065',
        '33529',
        '33199',
        '33009',
        '33527',
        '33122',
        '33422',
        '33090',
        '33363',
        '33366',
        '33018',
        '33433',
        '33397',
        '33483',
        '33238',
        '33080',
        '33274',
        '33535',
        '33099',
        '33324',
        '33234',
        '33322',
        '34255',
        '34247',
        '34301',
        '34108',
        '34157',
        '34150',
        '34023',
        '34113',
        '34213',
        '34341',
        '34172',
        '34057',
        '34129',
        '34123',
        '34270',
        '34337',
        '34198',
        '34090',
        '34116',
        '34202',
        '34022',
        '34095',
        '34327',
        '34088',
        '34120',
        '34058',
        '34217',
        '34077',
        '34259',
        '34169',
        '34087',
        '34148',
        '34145',
        '34151',
        '34146',
        '34032',
        '34299',
        '34298',
        '34300',
        '34324',
        '34336',
        '34003',
        '34199',
        '34332',
        '34031',
        '34101',
        '34162',
        '35360',
        '35068',
        '35006',
        '35125',
        '35115',
        '35238',
        '35047',
        '35051',
        '35281',
        '35024',
        '35210',
        '35055',
        '35278',
        '35240',
        '35334',
        '35066',
        '35352',
        '35206',
        '35196',
        '35001',
        '35353',
        '35120',
        '35208',
        '35275',
        '35139',
        '35032',
        '35131',
        '35059',
        '35076',
        '35363',
        '35245',
        '35189',
        '35204',
        '35088',
        '35173',
        '35288',
        '35049',
        '35299',
        '35179',
        '36044',
        '36063',
        '36159',
        '36005',
        '36202',
        '37003',
        '37163',
        '37266',
        '37154',
        '37156',
        '37273',
        '37261',
        '37122',
        '37214',
        '37233',
        '37208',
        '37050',
        '37109',
        '37195',
        '37018',
        '37139',
        '37172',
        '37054',
        '37027',
        '38547',
        '38397',
        '38249',
        '38538',
        '38185',
        '38421',
        '38151',
        '38169',
        '38229',
        '38382',
        '38485',
        '38474',
        '38317',
        '38158',
        '38545',
        '38524',
        '38486',
        '38111',
        '38562',
        '38179',
        '38150',
        '38516',
        '38423',
        '38126',
        '38529',
        '38200',
        '38544',
        '38087',
        '38318',
        '69064',
        '38157',
        '38344',
        '38425',
        '38298',
        '38468',
        '38378',
        '38053',
        '38553',
        '38193',
        '38537',
        '38449',
        '38348',
        '38455',
        '38563',
        '38565',
        '38517',
        '38239',
        '38337',
        '38133',
        '38400',
        '39198',
        '39526',
        '40312',
        '40273',
        '40088',
        '40279',
        '40192',
        '40281',
        '41018',
        '41295',
        '41047',
        '41269',
        '41149',
        '42187',
        '42184',
        '42127',
        '42071',
        '42332',
        '42147',
        '42279',
        '42304',
        '42256',
        '42022',
        '42285',
        '42323',
        '42218',
        '42207',
        '42095',
        '42186',
        '42044',
        '42005',
        '42189',
        '42316',
        '42302',
        '42183',
        '42330',
        '42305',
        '42237',
        '42275',
        '42223',
        '42222',
        '42103',
        '42123',
        '42110',
        '42271',
        '42097',
        '42225',
        '42099',
        '42259',
        '42234',
        '43157',
        '43041',
        '43089',
        '43012',
        '44131',
        '44005',
        '44186',
        '44182',
        '44021',
        '44126',
        '44012',
        '44071',
        '44109',
        '44162',
        '44143',
        '44190',
        '44114',
        '44215',
        '44047',
        '44026',
        '44035',
        '44020',
        '44172',
        '44204',
        '44009',
        '44198',
        '44194',
        '44018',
        '44101',
        '44166',
        '44120',
        '44074',
        '44150',
        '44130',
        '44154',
        '44069',
        '44055',
        '44072',
        '44175',
        '44211',
        '44049',
        '44135',
        '44184',
        '44132',
        '44210',
        '44052',
        '44103',
        '44151',
        '44030',
        '44168',
        '45234',
        '45232',
        '45284',
        '45147',
        '45302',
        '45285',
        '45075',
        '45169',
        '45286',
        '45089',
        '45274',
        '45298',
        '45235',
        '47157',
        '47310',
        '47001',
        '47201',
        '47032',
        '47031',
        '47100',
        '47209',
        '47145',
        '49301',
        '49023',
        '49092',
        '49244',
        '49069',
        '49218',
        '49167',
        '49099',
        '49373',
        '49332',
        '49193',
        '49328',
        '49125',
        '49261',
        '49180',
        '49215',
        '49007',
        '49307',
        '49353',
        '49015',
        '49246',
        '49267',
        '49323',
        '49214',
        '49035',
        '49200',
        '49223',
        '49377',
        '49020',
        '49129',
        '49298',
        '49278',
        '50002',
        '50601',
        '50139',
        '50041',
        '50082',
        '51108',
        '51506',
        '51388',
        '51242',
        '51454',
        '51573',
        '51055',
        '51172',
        '51250',
        '51662',
        '51058',
        '51474',
        '52448',
        '53130',
        '53201',
        '53054',
        '53034',
        '53119',
        '53140',
        '54323',
        '54382',
        '54261',
        '54270',
        '54314',
        '54451',
        '54115',
        '54215',
        '54318',
        '54430',
        '54090',
        '54395',
        '54547',
        '54304',
        '54578',
        '54482',
        '54357',
        '54274',
        '54526',
        '54184',
        '54339',
        '54300',
        '54328',
        '54257',
        '54498',
        '54439',
        '54495',
        '56121',
        '56098',
        '56162',
        '56083',
        '56078',
        '56185',
        '56107',
        '56101',
        '56036',
        '56090',
        '56166',
        '56193',
        '56118',
        '56179',
        '56260',
        '56206',
        '56243',
        '56240',
        '56251',
        '56164',
        '56053',
        '56158',
        '56067',
        '56003',
        '56248',
        '56008',
        '56231',
        '56247',
        '57463',
        '57480',
        '57751',
        '57447',
        '57487',
        '57049',
        '57032',
        '57412',
        '57616',
        '57433',
        '57283',
        '57663',
        '57474',
        '57631',
        '57628',
        '57227',
        '57660',
        '57058',
        '57537',
        '57240',
        '57332',
        '57306',
        '57206',
        '57221',
        '57683',
        '57012',
        '57508',
        '57647',
        '57019',
        '57591',
        '57491',
        '57143',
        '57672',
        '57757',
        '57666',
        '58194',
        '58303',
        '58117',
        '58160',
        '58088',
        '58121',
        '59295',
        '59043',
        '59431',
        '59580',
        '59592',
        '59092',
        '59284',
        '59504',
        '59230',
        '59514',
        '59239',
        '59489',
        '59428',
        '59378',
        '59328',
        '59368',
        '59163',
        '59646',
        '59279',
        '59507',
        '59220',
        '59367',
        '59508',
        '59421',
        '59527',
        '59152',
        '59386',
        '59636',
        '59011',
        '59426',
        '59090',
        '59339',
        '59343',
        '59143',
        '59457',
        '59352',
        '59317',
        '59653',
        '59482',
        '59553',
        '59524',
        '59656',
        '59044',
        '59202',
        '59052',
        '59098',
        '59278',
        '59566',
        '59477',
        '59598',
        '59585',
        '59005',
        '59588',
        '59107',
        '59260',
        '59400',
        '59212',
        '59268',
        '62502',
        '62491',
        '62736',
        '59459',
        '59301',
        '59369',
        '60159',
        '60382',
        '60338',
        '60667',
        '60057',
        '60103',
        '60175',
        '60463',
        '60414',
        '60684',
        '60584',
        '60360',
        '60342',
        '60636',
        '60670',
        '61001',
        '61397',
        '62041',
        '62004',
        '62753',
        '62263',
        '62099',
        '62764',
        '62744',
        '62173',
        '62865',
        '62119',
        '62178',
        '62617',
        '62516',
        '62048',
        '62126',
        '62473',
        '62083',
        '62457',
        '62270',
        '62443',
        '62035',
        '62276',
        '62555',
        '62194',
        '62132',
        '62400',
        '62846',
        '62051',
        '62401',
        '62863',
        '62489',
        '62193',
        '62548',
        '62244',
        '62774',
        '62427',
        '62215',
        '62637',
        '62250',
        '62587',
        '62724',
        '62907',
        '62249',
        '62497',
        '62274',
        '62624',
        '62321',
        '62498',
        '62510',
        '62065',
        '62413',
        '62186',
        '62570',
        '62771',
        '62895',
        '62842',
        '62563',
        '62133',
        '62528',
        '62628',
        '62386',
        '62351',
        '62737',
        '62523',
        '62032',
        '62033',
        '62861',
        '62019',
        '62573',
        '62160',
        '62643',
        '62758',
        '62667',
        '62893',
        '62746',
        '62604',
        '62894',
        '63178',
        '63300',
        '63103',
        '63470',
        '63245',
        '63113',
        '63124',
        '63075',
        '63284',
        '63032',
        '63014',
        '63164',
        '63193',
        '63063',
        '63307',
        '63070',
        '63069',
        '63308',
        '63019',
        '63345',
        '63042',
        '63263',
        '64102',
        '64024',
        '64122',
        '64260',
        '64483',
        '64545',
        '64140',
        '64547',
        '64256',
        '64125',
        '64495',
        '64160',
        '64189',
        '64496',
        '64407',
        '64065',
        '64519',
        '64445',
        '64129',
        '64348',
        '64335',
        '64284',
        '64230',
        '64269',
        '64132',
        '64237',
        '64405',
        '66136',
        '66037',
        '66172',
        '66028',
        '66180',
        '66164',
        '66195',
        '66021',
        '66213',
        '66038',
        '66017',
        '66189',
        '66144',
        '66182',
        '66227',
        '66140',
        '66212',
        '66069',
        '66141',
        '67180',
        '67046',
        '67067',
        '67458',
        '67372',
        '67345',
        '67482',
        '67447',
        '67218',
        '67267',
        '67043',
        '67365',
        '67204',
        '67471',
        '67152',
        '67118',
        '67506',
        '67519',
        '67131',
        '67137',
        '67343',
        '67309',
        '67389',
        '67378',
        '67551',
        '67212',
        '68224',
        '68376',
        '68154',
        '68278',
        '68166',
        '68271',
        '68375',
        '68256',
        '68056',
        '68195',
        '68300',
        '68118',
        '68043',
        '68321',
        '68270',
        '68218',
        '68297',
        '68149',
        '68163',
        '68042',
        '68349',
        '68309',
        '68021',
        '68066',
        '68374',
        '68145',
        '68155',
        '68338',
        '69009',
        '69052',
        '69159',
        '69264',
        '69092',
        '01194',
        '69115',
        '69013',
        '69123',
        '69266',
        '69259',
        '69256',
        '69290',
        '69034',
        '69029',
        '69149',
        '69282',
        '69286',
        '69275',
        '69244',
        '69202',
        '69204',
        '69091',
        '69199',
        '69081',
        '69089',
        '69283',
        '69069',
        '69271',
        '69273',
        '69096',
        '69276',
        '69072',
        '69100',
        '69143',
        '69194',
        '69292',
        '69088',
        '69142',
        '69191',
        '69279',
        '69040',
        '69278',
        '69205',
        '69044',
        '69260',
        '69046',
        '69063',
        '69250',
        '69116',
        '69127',
        '69163',
        '69277',
        '69112',
        '69028',
        '69094',
        '69255',
        '69131',
        '69027',
        '69043',
        '69133',
        '69291',
        '69297',
        '69272',
        '69270',
        '71270',
        '71105',
        '71090',
        '71153',
        '71306',
        '71486',
        '71040',
        '71310',
        '71499',
        '71059',
        '71076',
        '71475',
        '71445',
        '71118',
        '71221',
        '72329',
        '72008',
        '72213',
        '72386',
        '72328',
        '72054',
        '72058',
        '72200',
        '73151',
        '73008',
        '73010',
        '73051',
        '73128',
        '73011',
        '73303',
        '73065',
        '73179',
        '73213',
        '73087',
        '73222',
        '73064',
        '73029',
        '73031',
        '73137',
        '73030',
        '74042',
        '74164',
        '74012',
        '74133',
        '74298',
        '74305',
        '74094',
        '74008',
        '74229',
        '74081',
        '74264',
        '74278',
        '74169',
        '74010',
        '74282',
        '74213',
        '74112',
        '74242',
        '74267',
        '74137',
        '74019',
        '74281',
        '74105',
        '74263',
        '74043',
        '74005',
        '74293',
        '74119',
        '74218',
        '74272',
        '74026',
        '74220',
        '74311',
        '74128',
        '74243',
        '74082',
        '74224',
        '74250',
        '74104',
        '75056',
        '93066',
        '92012',
        '93048',
        '95018',
        '92050',
        '94081',
        '94028',
        '92004',
        '92025',
        '93001',
        '93005',
        '92026',
        '92063',
        '94017',
        '94068',
        '93051',
        '93029',
        '92044',
        '92040',
        '92024',
        '94041',
        '92002',
        '93055',
        '92051',
        '93007',
        '94076',
        '94046',
        '92023',
        '93008',
        '93031',
        '93070',
        '94033',
        '93071',
        '93010',
        '92036',
        '92073',
        '94080',
        '92048',
        '93027',
        '93046',
        '92049',
        '94022',
        '93064',
        '93053',
        '94002',
        '92062',
        '92007',
        '93006',
        '93032',
        '93072',
        '93078',
        '93050',
        '93073',
        '91589',
        '91027',
        '92020',
        '94078',
        '92019',
        '93063',
        '94058',
        '94052',
        '94079',
        '94073',
        '94038',
        '91687',
        '94016',
        '92046',
        '92064',
        '93077',
        '92035',
        '92009',
        '93014',
        '94034',
        '92060',
        '94018',
        '92075',
        '93047',
        '94044',
        '94071',
        '92078',
        '93057',
        '92032',
        '94054',
        '94043',
        '93045',
        '92072',
        '93049',
        '94003',
        '92014',
        '94067',
        '94059',
        '92071',
        '94077',
        '94042',
        '92022',
        '94021',
        '91326',
        '94037',
        '94011',
        '94015',
        '94019',
        '92033',
        '94004',
        '93061',
        '93013',
        '93062',
        '94074',
        '94069',
        '91432',
        '93079',
        '94060',
        '93030',
        '94075',
        '92077',
        '94055',
        '92076',
        '93039',
        '91479',
        '93074',
        '93033',
        '94001',
        '94065',
        '93015',
        '94047',
        '94048',
        '94053',
        '94070',
        '94056',
        '92047',
        '76540',
        '76681',
        '76575',
        '76322',
        '76498',
        '76451',
        '76231',
        '76108',
        '76157',
        '76484',
        '76410',
        '76216',
        '76165',
        '76319',
        '76212',
        '76497',
        '76561',
        '76095',
        '76640',
        '76429',
        '76474',
        '76103',
        '76475',
        '76402',
        '76178',
        '76709',
        '76366',
        '76222',
        '76116',
        '76377',
        '76599',
        '76452',
        '76351',
        '76447',
        '76305',
        '76341',
        '76552',
        '76481',
        '76647',
        '77350',
        '77249',
        '77108',
        '77373',
        '77083',
        '77390',
        '77468',
        '77337',
        '77258',
        '77479',
        '77169',
        '77139',
        '77055',
        '77146',
        '77284',
        '77330',
        '77382',
        '77143',
        '77475',
        '77513',
        '77335',
        '77437',
        '77186',
        '77014',
        '77037',
        '77131',
        '77183',
        '77320',
        '77142',
        '77238',
        '77288',
        '77152',
        '77285',
        '77407',
        '77487',
        '77389',
        '77378',
        '77040',
        '77394',
        '77255',
        '77449',
        '77111',
        '77058',
        '77243',
        '77307',
        '77464',
        '77438',
        '77085',
        '77372',
        '77181',
        '77155',
        '77121',
        '77124',
        '77075',
        '77053',
        '77450',
        '91631',
        '78575',
        '78397',
        '78160',
        '78586',
        '78551',
        '95063',
        '78311',
        '78146',
        '78358',
        '78372',
        '78650',
        '78481',
        '78124',
        '78418',
        '78190',
        '78350',
        '78396',
        '78133',
        '78502',
        '78224',
        '78367',
        '78621',
        '78423',
        '78490',
        '78297',
        '78208',
        '78383',
        '78165',
        '78674',
        '78688',
        '78356',
        '78644',
        '78168',
        '78361',
        '78498',
        '78172',
        '78440',
        '78362',
        '78005',
        '78123',
        '78335',
        '78642',
        '78015',
        '78029',
        '78624',
        '78138',
        '78643',
        '78401',
        '78267',
        '78466',
        '78531',
        '78217',
        '78354',
        '78672',
        '78638',
        '78206',
        '78327',
        '78402',
        '78314',
        '78118',
        '78501',
        '78299',
        '78403',
        '78239',
        '78517',
        '78220',
        '78486',
        '78537',
        '78003',
        '78646',
        '78158',
        '78640',
        '78545',
        '78126',
        '78686',
        '78073',
        '78242',
        '78092',
        '78322',
        '78455',
        '78117',
        '91064',
        '78043',
        '78343',
        '78321',
        '78683',
        '78442',
        '78550',
        '79049',
        '79079',
        '79195',
        '79179',
        '79062',
        '79191',
        '79081',
        '79003',
        '79355',
        '79109',
        '80021',
        '80489',
        '80164',
        '80725',
        '80674',
        '81099',
        '81105',
        '81220',
        '81145',
        '81273',
        '81065',
        '81163',
        '81120',
        '81021',
        '81004',
        '81257',
        '81144',
        '81218',
        '82075',
        '82161',
        '82121',
        '82124',
        '82025',
        '83049',
        '83061',
        '83118',
        '83107',
        '83099',
        '83116',
        '83023',
        '83097',
        '83064',
        '83106',
        '83140',
        '83087',
        '83143',
        '83123',
        '83112',
        '83016',
        '83009',
        '83035',
        '83027',
        '83130',
        '83054',
        '83131',
        '83050',
        '83148',
        '83086',
        '83072',
        '83004',
        '83141',
        '83058',
        '83121',
        '83137',
        '83126',
        '83069',
        '83129',
        '83062',
        '83144',
        '83047',
        '83090',
        '83098',
        '83034',
        '83153',
        '83103',
        '84035',
        '84099',
        '84038',
        '84065',
        '84031',
        '84072',
        '84004',
        '84122',
        '84087',
        '84039',
        '84056',
        '84007',
        '84092',
        '30351',
        '84141',
        '84081',
        '84043',
        '30011',
        '30217',
        '84034',
        '30221',
        '84119',
        '30209',
        '84129',
        '84080',
        '84088',
        '84016',
        '84054',
        '84132',
        '85146',
        '85039',
        '85197',
        '85262',
        '85190',
        '85194',
        '85047',
        '85096',
        '85018',
        '85191',
        '85008',
        '85089',
        '85155',
        '85300',
        '85081',
        '85213',
        '85046',
        '86194',
        '86041',
        '86115',
        '86214',
        '86070',
        '86297',
        '86158',
        '86157',
        '86062',
        '86222',
        '86100',
        '86163',
        '86066',
        '86174',
        '87085',
        '87114',
        '87050',
        '87075',
        '87065',
        '87113',
        '87048',
        '87201',
        '87125',
        '88160',
        '88209',
        '88465',
        '88090',
        '88413',
        '88372',
        '89024',
        '89263',
        '89387',
        '89464',
        '89287',
        '90010',
        '90099',
        '90008',
        '90075',
        '90032',
        '91223',
        '91433',
        '91016',
        '91377',
        '91477',
        '91692',
        '91272',
        '91345',
        '91161',
        '91471',
        '91645',
        '91312',
        '91216',
        '91661',
        '91122',
        '91425',
        '91363',
        '91665',
        '91339',
        '91689',
        '91587',
        '91044',
        '91458',
        '91534',
        '91275',
        '91136',
        '91666',
        '91635',
        '91549',
        '91103',
        '91570',
        '91434',
        '91235',
        '91552',
        '91021',
        '91105',
        '91667',
        '91207',
        '91347',
        '91376',
        '91461',
        '91685',
        '91457',
        '91333',
        '91494',
        '91115',
        '91657',
        '91201',
        '91691',
        '91114',
        '91421',
        '91215',
        '91191',
        '91514',
        '91097',
        '91228',
        '91174',
        '77445',
        '91521',
        '91286',
        '77122',
        '77296',
        '77251',
        '91573',
        '77067',
        '91086',
        '77495',
        '91553',
        '91600',
        '91340',
        '77326',
        '91577',
        '91659',
        '91179',
        '91617',
        '91225',
        '91386',
        '91045',
        '91315',
        '91232',
        '91468',
        '91244',
        '95585',
        '95268',
        '95280',
        '95680',
        '95277',
        '77514',
        '77294',
        '95019',
        '77118',
        '95351',
        '77153',
        '95250',
        '95205',
        '77349',
        '95371',
        '95612',
        '95604',
        '77420',
        '95509',
        '95527',
        '95197',
        '95428',
        '95555',
        '95598',
        '95199',
        '95539',
        '95427',
        '95210',
        '95229',
        '95288',
        '95574',
        '95091',
        '95426',
        '95369',
        '95014',
        '95252',
        '95306',
        '95219',
        '95176',
        '95607',
        '95582',
        '95203',
        '95424',
        '95563',
        '95488',
        '95051',
        '95060',
        '95491',
        '95257',
        '95256',
        '95127',
        '95500',
        '95572',
        '95218',
        '95476',
        '95323',
        '95637',
        '95183',
        '95388',
        '78382',
        '95450',
        '95039',
        '95120',
        '95446',
        '95313',
        '95394',
        '95480',
        '95392',
        '95134',
        '97101',
        '97103',
        '97120',
        '97113',
        '97128',
        '97125',
        '97117',
        '97116',
        '97119',
        '97122',
        '97102',
        '97118',
        '97115',
        '97129',
        '97114',
        '97121',
        '97111',
        '97107',
        '97124',
        '97105',
        '97132',
        '97109',
        '97134',
        '97106',
        '97104',
        '97222',
        '97228',
        '97230',
        '97212',
        '97214',
        '97205',
        '97218',
        '97225',
        '97204',
        '97207',
        '97210',
        '97221',
        '97220',
        '97223',
        '97227',
        '97217',
        '97232',
        '97231',
        '97206',
        '97226',
        '97202',
        '97209',
        '97213',
        '97229',
        '97224',
        '97306',
        '97360',
        '97357',
        '97353',
        '97362',
        '97309',
        '97416',
        '97414',
        '97404',
        '97405',
        '97401',
        '97424',
        '97422',
        '97412',
        '97403',
        '97417',
        '97409',
        '97410',
        '97402',
        '97421',
        '97406',
        '97419',
        '97415',
        '97408',
        '97413',
        '97407',
        '97423',
        '97411',
        '97418',
        '97420',
        '2A004',
        '2A006',
        '2B037',
        '2B033',
        '2B120',
    ],
    nb_log: [
        804,
        322,
        4587,
        546,
        849,
        594,
        8218,
        530,
        715,
        502,
        762,
        322,
        1613,
        1481,
        773,
        481,
        519,
        1076,
        291,
        433,
        8823,
        544,
        2767,
        5733,
        708,
        5126,
        515,
        303,
        3848,
        945,
        445,
        2732,
        1616,
        872,
        379,
        2099,
        371,
        158,
        205,
        102,
        292,
        4281,
        28177,
        2538,
        2192,
        803,
        1183,
        730,
        140,
        659,
        301,
        439,
        239,
        75,
        451,
        81,
        115,
        214,
        33,
        3824,
        751,
        544,
        184,
        264,
        33,
        90,
        7845,
        2240,
        1358,
        1267,
        1914,
        543,
        850,
        89,
        5591,
        1410,
        935,
        1508,
        673,
        256,
        287,
        94,
        48,
        111,
        205,
        715,
        516,
        984,
        10668,
        4078,
        793,
        405,
        308,
        12646,
        1772,
        3216,
        1395,
        799,
        878,
        523,
        287,
        5991,
        637,
        164,
        7254,
        626,
        240,
        242,
        185,
        281,
        145,
        102,
        2121,
        1257,
        309,
        120,
        1263,
        382,
        257,
        230,
        129,
        185,
        254,
        280,
        87326,
        15862,
        7162,
        5722,
        5014,
        5900,
        4752,
        4745,
        2322,
        4731,
        916,
        2562,
        698,
        1180,
        1559,
        3237,
        1271,
        771,
        1819,
        645,
        706,
        805,
        563,
        425,
        380,
        275,
        356,
        383,
        400,
        340,
        322,
        364,
        471,
        653,
        1906,
        291,
        199,
        277,
        232,
        485,
        501,
        214,
        456,
        624,
        143,
        446,
        305,
        151,
        255,
        355,
        217,
        254,
        472,
        146,
        295,
        46,
        202,
        166,
        477,
        701,
        315,
        311,
        332,
        197,
        125,
        265,
        276,
        81,
        107,
        223,
        100,
        48,
        6414,
        1103,
        1255,
        17517,
        6435,
        1810,
        1845,
        944,
        1783,
        244,
        1298,
        925,
        515,
        866,
        433,
        407,
        200,
        3930,
        999,
        625,
        414,
        4520,
        385,
        263,
        2137,
        285,
        266,
        157,
        6555,
        1802,
        912,
        424,
        563,
        470,
        535,
        66,
        54,
        26,
        243,
        2908,
        61,
        2906,
        411,
        166,
        143,
        13464,
        1137,
        776,
        720,
        488,
        467,
        327,
        365,
        319,
        139,
        173,
        1614,
        351,
        196,
        195,
        347,
        103,
        116,
        10555,
        963,
        369,
        581,
        62,
        146,
        4316,
        440,
        267,
        115,
        183,
        160,
        2639,
        694,
        17554,
        2628,
        1634,
        1188,
        1401,
        674,
        1294,
        744,
        435,
        2503,
        500,
        247,
        157,
        131,
        234,
        778,
        227,
        83,
        115,
        6133,
        1136,
        1029,
        509,
        539,
        392,
        358,
        376,
        269,
        104,
        178,
        229,
        4345,
        924,
        849,
        481,
        140,
        264,
        60,
        2512,
        171,
        4438,
        2393,
        1272,
        426,
        1004,
        867,
        669,
        508,
        1025,
        419,
        330,
        441,
        18956,
        366,
        3890,
        9045,
        4594,
        1741,
        1177,
        1439,
        355,
        397,
        341,
        344,
        279,
        247,
        232,
        225,
        118,
        10509,
        565,
        558,
        264,
        3856,
        988,
        60,
        386,
        402,
        3448,
        3143,
        1274,
        636,
        388,
        322,
        5953,
        4209,
        1945,
        720,
        484,
        328,
        360,
        258,
        4820,
        1786,
        433,
        427,
        152,
        8391,
        645,
        440,
        326,
        293,
        19284,
        938,
        796,
        985,
        1100,
        551,
        439,
        142,
        2414,
        552,
        229,
        2207,
        297,
        376,
        382,
        2845,
        968,
        444,
        7697,
        422,
        167,
        925,
        414,
        166,
        81,
        353,
        268,
        77,
        18107,
        1010,
        298,
        318,
        450,
        207,
        199,
        173,
        68,
        181,
        207,
        214,
        50,
        235,
        194,
        2918,
        805,
        561,
        609,
        648,
        800,
        413,
        537,
        387,
        343,
        313,
        58502,
        4857,
        2522,
        2818,
        1882,
        1796,
        1330,
        713,
        928,
        841,
        1036,
        804,
        725,
        502,
        726,
        883,
        1039,
        591,
        702,
        471,
        681,
        446,
        508,
        382,
        322,
        1623,
        1712,
        602,
        928,
        824,
        1690,
        740,
        441,
        228,
        315,
        182,
        2478,
        504,
        203,
        473,
        277,
        28537,
        8677,
        8884,
        5968,
        4778,
        2761,
        4297,
        4291,
        2939,
        5127,
        3208,
        2606,
        2183,
        3145,
        1738,
        2198,
        1182,
        630,
        928,
        933,
        871,
        1110,
        535,
        393,
        76,
        2194,
        1287,
        1107,
        707,
        1403,
        694,
        597,
        81,
        774,
        59,
        663,
        277,
        286,
        822,
        519,
        67,
        503,
        406,
        296,
        120,
        261,
        354,
        312,
        5035,
        2062,
        736,
        434,
        496,
        371,
        97,
        45,
        37149,
        2494,
        1029,
        1027,
        997,
        657,
        627,
        595,
        694,
        597,
        622,
        268,
        424,
        346,
        531,
        479,
        311,
        484,
        258,
        71,
        153,
        325,
        1979,
        268,
        334,
        8746,
        432,
        303,
        290,
        60,
        308,
        1776,
        1029,
        249,
        285,
        301,
        343,
        2015,
        460,
        290,
        249,
        3327,
        35718,
        1749,
        2191,
        2001,
        1007,
        846,
        1381,
        608,
        1022,
        672,
        926,
        650,
        935,
        620,
        544,
        582,
        412,
        522,
        555,
        246,
        319,
        568,
        416,
        394,
        334,
        184,
        375,
        225,
        262,
        494,
        7909,
        457,
        248,
        152,
        7803,
        715,
        250,
        199,
        158,
        1809,
        406,
        377,
        319,
        1111,
        394,
        21162,
        5149,
        1725,
        3358,
        1140,
        1485,
        591,
        1577,
        701,
        371,
        272,
        173,
        605,
        715,
        379,
        376,
        443,
        20532,
        6702,
        6649,
        2995,
        1560,
        1792,
        808,
        786,
        1486,
        1189,
        537,
        585,
        615,
        498,
        910,
        870,
        691,
        629,
        706,
        245,
        121,
        276,
        4807,
        838,
        980,
        462,
        220,
        767,
        610,
        712,
        382,
        267,
        4407,
        4395,
        2933,
        738,
        645,
        251,
        109,
        2925,
        1007,
        720,
        706,
        697,
        275,
        384,
        3815,
        208,
        508,
        1461,
        3302,
        919,
        3013,
        1419,
        8365,
        533,
        285,
        2584,
        247,
        6037,
        992,
        932,
        1101,
        143,
        2103,
        982,
        400,
        359,
        433,
        226,
        406,
        26205,
        6492,
        3756,
        2330,
        2488,
        1372,
        1202,
        1199,
        551,
        1593,
        499,
        873,
        671,
        610,
        642,
        323,
        786,
        561,
        914,
        733,
        335,
        98,
        395,
        159,
        211,
        2685,
        444,
        336,
        565,
        449,
        153,
        305,
        182,
        142,
        103,
        55,
        274,
        46792,
        6196,
        4976,
        2295,
        2579,
        1288,
        2068,
        1550,
        1355,
        1981,
        1470,
        733,
        479,
        794,
        625,
        530,
        476,
        439,
        383,
        336,
        118,
        199,
        615,
        1132,
        1049,
        371,
        165,
        243,
        286,
        384,
        11117,
        673,
        960,
        541,
        832,
        301,
        250,
        185,
        15285,
        1416,
        2380,
        2911,
        1967,
        2157,
        703,
        795,
        650,
        513,
        443,
        513,
        226,
        1384,
        610,
        4940,
        901,
        521,
        333,
        510,
        334,
        230,
        1089,
        1256,
        1332,
        1076,
        582,
        629,
        139,
        5617,
        441,
        187,
        261,
        3846,
        728,
        499,
        658,
        422,
        29966,
        829,
        3128,
        1694,
        1800,
        1757,
        1076,
        1037,
        454,
        421,
        633,
        196,
        491,
        504,
        185,
        368,
        360,
        348,
        294,
        789,
        441,
        10312,
        1248,
        607,
        313,
        42165,
        1673,
        876,
        699,
        950,
        591,
        530,
        556,
        4518,
        8323,
        669,
        385,
        413,
        404,
        284,
        3120,
        1613,
        468,
        113,
        334,
        144,
        1020,
        699,
        375,
        496,
        258,
        14310,
        5472,
        2136,
        1593,
        1230,
        2603,
        1757,
        850,
        1257,
        954,
        729,
        550,
        603,
        467,
        738,
        398,
        9711,
        3042,
        1185,
        1903,
        617,
        531,
        466,
        284,
        518,
        411,
        255,
        459,
        179,
        295,
        7350,
        1018,
        770,
        371,
        513,
        392,
        479,
        457,
        321,
        288,
        193,
        314,
        205,
        158,
        21711,
        3553,
        3879,
        963,
        592,
        615,
        555,
        311,
        224,
        1271,
        1187,
        913,
        595,
        2530,
        127,
        2884,
        1676,
        2054,
        565,
        2247,
        932,
        1405,
        1786,
        1583,
        863,
        440,
        287,
        380,
        1491,
        933,
        588,
        415,
        5981,
        2033,
        963,
        6461,
        1172,
        806,
        47,
        283,
        201,
        2245,
        1377,
        816,
        178,
        184,
        357,
        171,
        268,
        496,
        296,
        333,
        291,
        517,
        3459,
        2211,
        2968,
        2219,
        2214,
        2292,
        2485,
        1523,
        1508,
        1224,
        915,
        1518,
        1543,
        1451,
        1151,
        801,
        659,
        751,
        784,
        922,
        935,
        724,
        828,
        595,
        701,
        578,
        285,
        319,
        663,
        378,
        430,
        469,
        366,
        298,
        167,
        375,
        304,
        220,
        147,
        906,
        291,
        219,
        803,
        473,
        448,
        327,
        238,
        157,
        487,
        194,
        226,
        7805,
        1030,
        662,
        451,
        11480,
        366,
        8079,
        3756,
        2350,
        829,
        701,
        1127,
        1891,
        815,
        302,
        5603,
        284,
        7260,
        1046,
        1307,
        469,
        766,
        880,
        248,
        433,
        363,
        3617,
        5452,
        2371,
        838,
        1705,
        826,
        640,
        1805,
        1313,
        1454,
        1118,
        389,
        546,
        1530,
        1265,
        351,
        897,
        554,
        530,
        543,
        351,
        279,
        9872,
        659,
        419,
        455,
        4080,
        2655,
        2389,
        1438,
        1785,
        2095,
        1894,
        920,
        1038,
        764,
        1253,
        691,
        8821,
        7155,
        3745,
        2562,
        2459,
        2440,
        2506,
        1540,
        1279,
        1878,
        1631,
        874,
        2001,
        1852,
        1148,
        991,
        649,
        796,
        336,
        312,
        394,
        402,
        7070,
        1986,
        1313,
        1682,
        721,
        702,
        363,
        401,
        1834,
        2044,
        142,
        199,
        218,
        22855,
        2241,
        1150,
        1070,
        1037,
        1375,
        1082,
        938,
        827,
        779,
        534,
        544,
        431,
        715,
        108,
        354,
        16,
        7331,
        4031,
        1745,
        1501,
        1824,
        668,
        878,
        615,
        233,
        727,
        249,
        264,
        529,
        538,
        228,
        223,
        300,
        10950,
        1599,
        1200,
        699,
        696,
        225,
        210,
        352,
        277,
        333,
        12469,
        853,
        817,
        797,
        493,
        805,
        554,
        583,
        527,
        368,
        190,
        333,
        428,
        154,
        262,
        257,
        140,
        196,
        664,
        2621,
        1058,
        469,
        337,
        253,
        95,
        45215,
        5597,
        3647,
        2105,
        3194,
        1468,
        1039,
        518,
        409,
        391,
        421,
        119,
        292,
        384,
        575,
        365,
        320,
        186,
        286,
        224,
        15426,
        1308,
        1313,
        1007,
        984,
        1214,
        904,
        919,
        489,
        576,
        406,
        283,
        277,
        342,
        285,
        165,
        2670,
        978,
        286,
        255,
        188,
        198,
        140,
        10211,
        599,
        400,
        475,
        265,
        860,
        180,
        105,
        6148,
        962,
        830,
        409,
        406,
        64649,
        23890,
        13553,
        9799,
        6449,
        4377,
        4800,
        3904,
        3106,
        6538,
        3187,
        1712,
        1474,
        1737,
        3896,
        3561,
        2534,
        1272,
        1069,
        941,
        873,
        729,
        1329,
        1448,
        795,
        748,
        1067,
        219,
        804,
        750,
        767,
        520,
        22,
        708,
        433,
        287,
        373,
        468,
        127,
        279,
        300,
        334,
        393,
        146,
        679,
        414,
        311,
        480,
        375,
        159,
        1175,
        630,
        118,
        347,
        329,
        294,
        145,
        7198,
        810,
        180,
        4383,
        4283,
        831,
        723,
        1030,
        632,
        200,
        8643,
        763,
        596,
        475,
        207,
        136,
        413,
        449,
        262,
        194,
        216,
        335,
        115,
        202,
        3406,
        178,
        522,
        415,
        3040,
        1455,
        9548,
        998,
        1033,
        971,
        492,
        449,
        566,
        513,
        862,
        607,
        1358,
        451,
        4805,
        1231,
        908,
        923,
        434,
        613,
        115,
        2046,
        789,
        526,
        465,
        14401,
        230,
        654,
        736,
        405,
        219,
        165,
        283,
        4567,
        493,
        390,
        303,
        159,
        216,
        1258,
        941,
        400,
        436,
        640,
        163,
        98,
        1573,
        181,
        1130,
        517,
        233,
        271906,
        23541,
        9324,
        19973,
        15102,
        21638,
        15830,
        16490,
        8967,
        12745,
        15109,
        10847,
        9282,
        9134,
        14186,
        3653,
        8714,
        8843,
        6403,
        8169,
        10112,
        12268,
        6468,
        9958,
        1980,
        8357,
        9865,
        6317,
        7648,
        11088,
        7055,
        9930,
        7838,
        7645,
        9413,
        12807,
        7626,
        3098,
        5656,
        7887,
        4191,
        5387,
        7235,
        5596,
        8208,
        8713,
        6280,
        11217,
        7707,
        3746,
        8505,
        3984,
        6338,
        4334,
        3253,
        4868,
        4112,
        5266,
        6518,
        5484,
        2266,
        2636,
        4039,
        3095,
        3917,
        4837,
        5075,
        6185,
        2302,
        3420,
        2004,
        2642,
        3269,
        3880,
        4453,
        3684,
        3283,
        2351,
        3273,
        2367,
        5011,
        1784,
        4481,
        5143,
        4348,
        3158,
        2720,
        2130,
        4871,
        1900,
        1363,
        1881,
        2377,
        1870,
        2220,
        2445,
        3590,
        2452,
        4496,
        4453,
        1481,
        1861,
        1955,
        2640,
        3711,
        1817,
        717,
        3606,
        1572,
        1284,
        2819,
        1148,
        2900,
        626,
        694,
        329,
        429,
        2019,
        601,
        847,
        309,
        351,
        677,
        179,
        337,
        220,
        286,
        274,
        98,
        142,
        17222,
        4851,
        7087,
        9128,
        4095,
        2870,
        3802,
        749,
        4362,
        2219,
        3084,
        2327,
        1340,
        1988,
        2132,
        1627,
        1327,
        1043,
        1151,
        824,
        1151,
        574,
        471,
        858,
        1410,
        897,
        868,
        500,
        234,
        116,
        379,
        466,
        32205,
        2038,
        2745,
        2192,
        535,
        255,
        330,
        1705,
        308,
        5508,
        3585,
        4358,
        2064,
        3625,
        3324,
        1856,
        1458,
        618,
        374,
        682,
        80,
        9551,
        445,
        162,
        444,
        221,
        519,
        126,
        223,
        1769,
        1036,
        54,
        2390,
        665,
        161,
        90,
        408,
        7229,
        3619,
        3703,
        1621,
        966,
        431,
        360,
        234,
        275,
        219,
        1034,
        1039,
        2624,
        2282,
        1192,
        1047,
        715,
        411,
        490,
        304,
        238,
        334,
        137,
        1,
        1649,
        213,
        130,
        401,
        400,
        309,
        6252,
        4533,
        5990,
        2644,
        2241,
        1642,
        1190,
        1165,
        1699,
        1240,
        1193,
        1058,
        603,
        537,
        607,
        870,
        192,
        154,
        7208,
        3937,
        3459,
        6323,
        3013,
        1865,
        1743,
        945,
        972,
        1163,
        1676,
        762,
        7541,
        5547,
        3384,
        5170,
        3225,
        4277,
        2972,
        2588,
        1726,
        1050,
        1858,
        731,
        1553,
        941,
        1132,
        607,
        325,
        620,
        619,
        626,
        365,
        358,
        345,
        264,
        243,
        300,
        306,
        287,
        219,
        125,
        216,
        2721,
        423,
        232,
        223,
        168,
        8066,
        2399,
        2506,
        2818,
        1896,
        1363,
        1317,
        1704,
        762,
        1423,
        465,
        629,
        395,
        129,
        112,
        262,
        233,
        98,
        3,
        1114,
        380,
        432,
        236,
        581,
        7286,
        556,
        445,
        63,
        222,
        24596,
        1006,
        456,
        327,
        271,
        1025,
        848,
        129,
        124,
        81,
        3597,
        771,
        339,
        613,
        5094,
        637,
        213,
        74,
        251,
        131,
        5232,
        64,
        72,
        366,
        4211,
        2212,
        365,
        510,
        534,
        1617,
        110,
        93,
        0,
        57,
        9,
        124,
        970,
        655,
        297,
        539,
        213,
        135,
        884,
        613,
        113,
        3551,
        756,
        560,
        485,
        365,
        230,
        192,
        203,
        14827,
        6001,
        4450,
        2225,
        3437,
        1654,
        635,
        995,
        594,
        326,
        259,
        86,
        2772,
        223,
        114,
        48,
        3051,
        138,
        288,
        260,
        3091,
        233,
        270,
        14848,
        1466,
        875,
        952,
        639,
        804,
        526,
        306,
        353,
        297,
        306,
        22,
        1663,
        1167,
        366,
        339,
        1377,
        361,
        908,
        132,
        91,
        101,
        121,
        2671,
        1299,
        106,
        110,
        8131,
        288,
        216,
        234,
        146,
        160,
        171,
        167,
        15582,
        1012,
        491,
        561,
        561,
        210,
        398,
        327,
        551,
        203,
        149,
        122,
        4714,
        358,
        19719,
        1079,
        586,
        882,
        574,
        576,
        405,
        43,
        212,
        5835,
        1406,
        1025,
        646,
        3336,
        743,
        5840,
        335,
        4411,
        494,
        623,
        9160,
        572,
        460,
        483,
        343,
        3120,
        2,
        211,
        8157,
        5810,
        4663,
        3164,
        3024,
        1868,
        1892,
        1299,
        864,
        783,
        848,
        1308,
        839,
        673,
        615,
        797,
        321,
        569,
        470,
        180,
        262,
        193,
        76,
        102,
        69,
        4208,
        3376,
        2653,
        2386,
        2304,
        1048,
        1528,
        782,
        626,
        720,
        477,
        344,
        397,
        400,
        226,
        250,
        285,
        426,
        4722,
        3320,
        1822,
        2148,
        2359,
        1828,
        733,
        908,
        720,
        13521,
        7531,
        3522,
        3751,
        4211,
        2407,
        2161,
        1636,
        1025,
        838,
        900,
        715,
        607,
        514,
        805,
        708,
        243,
        458,
        454,
        313,
        178,
        1678,
        834,
        272,
        250,
        220,
        137,
        11562,
        6668,
        3413,
        5177,
        4592,
        2476,
        2005,
        445,
        788,
        1052,
        574,
        756,
        605,
        449,
        264,
        117,
        379,
        70,
        64,
        423,
        2136,
        2010,
        2945,
        1912,
        1339,
        1160,
        1423,
        877,
        824,
        425,
        566,
        731,
        109,
        226,
        163,
        3337,
        2487,
        4320,
        2134,
        2537,
        3209,
        2418,
        2625,
        1152,
        1007,
        864,
        1098,
        414,
        231,
        184,
        12220,
        4975,
        3512,
        2231,
        1463,
        1987,
        1617,
        621,
        613,
        370,
        360,
        251,
        140,
        48,
        1269,
        727,
        278,
        428,
        408,
        9883,
        4587,
        6765,
        1005,
        1159,
        581,
        1443,
        1262,
        173,
        790,
        121,
        2021,
        2312,
        1178,
        1337,
        115,
        78,
        966,
        1195,
        1884,
        561,
        880,
        338,
        306,
        236,
        1766,
        880,
        1328,
        545,
        711,
        456,
        218,
        650,
        342,
        1433,
        1027,
        1443,
        542,
        647,
        776,
        947,
        544,
        524,
        448,
        269,
        172,
        12225,
        4651,
        2056,
        962,
        205,
        67,
        20,
        30,
        4,
        1552,
        8113,
        4025,
        1040,
        314,
        654,
        65,
        5526,
        2190,
        301,
        193,
        5392,
        4936,
        1657,
        70,
        449,
        407,
        7499,
        4486,
        1746,
        7416,
        286,
        24758,
        4110,
        2390,
        5498,
        0,
        117,
        5287,
        341,
    ],
    sru_current: [
        0.261,
        0.1647,
        0.4883,
        0.2497,
        0.539,
        0.3827,
        0.4116,
        0.1843,
        0.2485,
        0.1845,
        0.2522,
        0.1697,
        0.2741,
        0.283,
        0.1984,
        0.1776,
        0.2487,
        0.2543,
        0.1402,
        0.2406,
        0.338,
        0.232,
        0.378,
        0.413,
        0.429,
        0.287,
        0.125,
        0.141,
        0.382,
        0.156,
        0.228,
        0.174,
        0.251,
        0.206,
        0.223,
        0.1829,
        0.1271,
        0.0777,
        0.1186,
        0.0556,
        0.1888,
        0.2126,
        0.1443,
        0.0968,
        0.1305,
        0.0812,
        0.219,
        0.1654,
        0.0474,
        0.2582,
        0.1311,
        0.2049,
        0.0848,
        0.0366,
        0.1787,
        0.0425,
        0.0608,
        0.1005,
        0.0241,
        0.1609,
        0.1511,
        0.1248,
        0.0537,
        0.1078,
        0.0166,
        0.0555,
        0.1777,
        0.0969,
        0.0935,
        0.1339,
        0.1027,
        0.0656,
        0.1203,
        0.0488,
        0.1297,
        0.0937,
        0.1002,
        0.2953,
        0.1472,
        0.0685,
        0.0872,
        0.0511,
        0.0236,
        0.0691,
        0.0627,
        0.1225,
        0.1476,
        0.2606,
        0.4782,
        0.5063,
        0.3196,
        0.2549,
        0.1968,
        0.4217,
        0.2928,
        0.6286,
        0.2504,
        0.2511,
        0.412,
        0.2544,
        0.1843,
        0.2647,
        0.2673,
        0.0822,
        0.2512,
        0.1885,
        0.0871,
        0.0885,
        0.0553,
        0.0892,
        0.0765,
        0.0409,
        0.155,
        0.2196,
        0.1083,
        0.0747,
        0.1609,
        0.1536,
        0.1191,
        0.1147,
        0.066,
        0.0973,
        0.1276,
        0.1887,
        0.2181,
        0.2132,
        0.3206,
        0.2743,
        0.2434,
        0.3041,
        0.2302,
        0.3112,
        0.1553,
        0.4254,
        0.0994,
        0.2536,
        0.0747,
        0.1225,
        0.2116,
        0.4373,
        0.1886,
        0.1262,
        0.335,
        0.1164,
        0.1305,
        0.1684,
        0.108,
        0.0881,
        0.0804,
        0.0666,
        0.0802,
        0.0899,
        0.0904,
        0.0868,
        0.0845,
        0.0977,
        0.1059,
        0.1683,
        0.4847,
        0.0747,
        0.0534,
        0.067,
        0.0684,
        0.1683,
        0.162,
        0.0722,
        0.1233,
        0.2212,
        0.0527,
        0.1498,
        0.0998,
        0.0545,
        0.1001,
        0.1357,
        0.0797,
        0.1039,
        0.1972,
        0.0559,
        0.1181,
        0.0147,
        0.074,
        0.0665,
        0.2083,
        0.3433,
        0.1319,
        0.138,
        0.1418,
        0.085,
        0.0603,
        0.1314,
        0.1449,
        0.0446,
        0.0637,
        0.1355,
        0.0661,
        0.0288,
        0.2539,
        0.1731,
        0.2064,
        0.3095,
        0.6476,
        0.3624,
        0.3741,
        0.1827,
        0.5431,
        0.0983,
        0.4693,
        0.335,
        0.2233,
        0.4122,
        0.2167,
        0.2229,
        0.1273,
        0.4087,
        0.2538,
        0.1936,
        0.1514,
        0.312,
        0.1259,
        0.1439,
        0.2287,
        0.1282,
        0.1493,
        0.094,
        0.3036,
        0.4087,
        0.2437,
        0.1243,
        0.1551,
        0.1634,
        0.2141,
        0.0276,
        0.0278,
        0.0158,
        0.1415,
        0.2125,
        0.0354,
        0.2284,
        0.1026,
        0.0663,
        0.0823,
        0.3062,
        0.2232,
        0.1786,
        0.197,
        0.1607,
        0.1233,
        0.115,
        0.1301,
        0.1237,
        0.0674,
        0.0889,
        0.1268,
        0.09266,
        0.0574,
        0.0729,
        0.1281,
        0.0402,
        0.0567,
        0.3326,
        0.2231,
        0.1156,
        0.2611,
        0.0349,
        0.0891,
        0.1788,
        0.1105,
        0.1196,
        0.0597,
        0.0994,
        0.0844,
        0.2326,
        0.2716,
        0.2158,
        0.4667,
        0.3072,
        0.2255,
        0.3542,
        0.149,
        0.3158,
        0.206,
        0.1798,
        0.2461,
        0.1131,
        0.1081,
        0.0739,
        0.0761,
        0.1157,
        0.0951,
        0.0868,
        0.048,
        0.0479,
        0.2667,
        0.1621,
        0.1964,
        0.1286,
        0.1426,
        0.1134,
        0.0944,
        0.1262,
        0.1151,
        0.0545,
        0.0917,
        0.1226,
        0.267,
        0.1904,
        0.2265,
        0.1329,
        0.0669,
        0.1256,
        0.0289,
        0.1743,
        0.09,
        0.438,
        0.412,
        0.312,
        0.16,
        0.488,
        0.511,
        0.331,
        0.268,
        0.597,
        0.279,
        0.214,
        0.28,
        0.329,
        0.171,
        0.2051,
        0.2828,
        0.28189,
        0.1888,
        0.2553,
        0.2833,
        0.1157,
        0.1505,
        0.1374,
        0.1508,
        0.1592,
        0.1332,
        0.1268,
        0.128,
        0.074,
        0.491,
        0.253,
        0.3,
        0.159,
        0.35,
        0.293,
        0.024,
        0.166,
        0.2047,
        0.428,
        0.735,
        0.435,
        0.295,
        0.23,
        0.204,
        0.3081,
        0.5503,
        0.4077,
        0.2311,
        0.21,
        0.1595,
        0.2,
        0.1736,
        0.4012,
        0.4133,
        0.2517,
        0.2655,
        0.094,
        0.2552,
        0.1733,
        0.1816,
        0.1688,
        0.1557,
        0.2772,
        0.14,
        0.1339,
        0.1862,
        0.2075,
        0.1604,
        0.1571,
        0.1004,
        0.2111,
        0.1532,
        0.0615,
        0.2807,
        0.1325,
        0.156,
        0.1843,
        0.3322,
        0.195,
        0.1798,
        0.3755,
        0.1238,
        0.0667,
        0.4115,
        0.1984,
        0.0765,
        0.0418,
        0.2044,
        0.1287,
        0.0472,
        0.2498,
        0.1662,
        0.0797,
        0.1082,
        0.1701,
        0.0774,
        0.0927,
        0.0871,
        0.037,
        0.1007,
        0.1243,
        0.1148,
        0.0275,
        0.0813,
        0.0987,
        0.2602,
        0.1499,
        0.141,
        0.145,
        0.1571,
        0.1998,
        0.1499,
        0.1974,
        0.1709,
        0.1803,
        0.1673,
        0.2259,
        0.2805,
        0.1882,
        0.2213,
        0.2103,
        0.2303,
        0.1948,
        0.1268,
        0.1771,
        0.1677,
        0.2138,
        0.1777,
        0.184,
        0.1327,
        0.186,
        0.2419,
        0.2839,
        0.1781,
        0.2349,
        0.1633,
        0.2256,
        0.1679,
        0.1941,
        0.1836,
        0.1594,
        0.2118,
        0.2477,
        0.1945,
        0.4347,
        0.39,
        0.1942,
        0.1688,
        0.1228,
        0.1048,
        0.1639,
        0.1029,
        0.2107,
        0.1244,
        0.0809,
        0.2067,
        0.155,
        0.2048,
        0.2372,
        0.3157,
        0.2728,
        0.2454,
        0.1983,
        0.2828,
        0.3532,
        0.2457,
        0.4798,
        0.2917,
        0.21,
        0.2218,
        0.3975,
        0.2464,
        0.2933,
        0.2209,
        0.1387,
        0.1967,
        0.2485,
        0.2519,
        0.2937,
        0.1606,
        0.1268,
        0.0636,
        0.1511,
        0.1145,
        0.1472,
        0.1691,
        0.1884,
        0.1828,
        0.2188,
        0.0427,
        0.1421,
        0.0387,
        0.1594,
        0.1392,
        0.1353,
        0.1733,
        0.1787,
        0.0473,
        0.2315,
        0.2236,
        0.1427,
        0.075,
        0.0918,
        0.0802,
        0.1424,
        0.2057,
        0.179,
        0.123,
        0.0921,
        0.1311,
        0.1355,
        0.0359,
        0.0286,
        0.2506,
        0.1936,
        0.1218,
        0.1771,
        0.1625,
        0.16,
        0.1366,
        0.1429,
        0.1701,
        0.1702,
        0.1806,
        0.0811,
        0.1339,
        0.1189,
        0.1857,
        0.1648,
        0.1155,
        0.1948,
        0.1071,
        0.0392,
        0.1153,
        0.1508,
        0.1702,
        0.0831,
        0.1806,
        0.2184,
        0.0947,
        0.118,
        0.1234,
        0.0189,
        0.1413,
        0.0957,
        0.2492,
        0.0805,
        0.1164,
        0.1332,
        0.1732,
        0.2288,
        0.1498,
        0.151,
        0.1249,
        0.3146,
        0.3174,
        0.1962,
        0.2534,
        0.3026,
        0.1791,
        0.1759,
        0.2678,
        0.1391,
        0.253,
        0.1879,
        0.2231,
        0.1834,
        0.2491,
        0.1696,
        0.1813,
        0.2374,
        0.1689,
        0.2216,
        0.2419,
        0.1135,
        0.1724,
        0.2701,
        0.2023,
        0.1942,
        0.1792,
        0.11,
        0.2207,
        0.1518,
        0.1797,
        0.1594,
        0.2928,
        0.151,
        0.1165,
        0.0792,
        0.3543,
        0.2015,
        0.0939,
        0.1138,
        0.1162,
        0.3052,
        0.2242,
        0.1303,
        0.1568,
        0.2295,
        0.1729,
        0.2844,
        0.3075,
        0.2059,
        0.4827,
        0.1732,
        0.2507,
        0.1286,
        0.2968,
        0.1928,
        0.1827,
        0.1425,
        0.1198,
        0.2411,
        0.218,
        0.122,
        0.152,
        0.222,
        0.251,
        0.443,
        0.439,
        0.288,
        0.179,
        0.231,
        0.147,
        0.156,
        0.326,
        0.251,
        0.148,
        0.196,
        0.176,
        0.143,
        0.269,
        0.247,
        0.225,
        0.215,
        0.289,
        0.138,
        0.067,
        0.166,
        0.329,
        0.332,
        0.376,
        0.2585,
        0.146,
        0.213,
        0.243,
        0.249,
        0.204,
        0.171,
        0.325,
        0.647,
        0.463,
        0.252,
        0.313,
        0.122,
        0.064,
        0.262,
        0.235,
        0.215,
        0.206,
        0.237,
        0.12,
        0.272,
        0.3227,
        0.1145,
        0.221,
        0.1789,
        0.2558,
        0.1918,
        0.208,
        0.1818,
        0.36,
        0.1503,
        0.1323,
        0.3113,
        0.1279,
        0.318,
        0.184,
        0.281,
        0.303,
        0.066,
        0.264,
        0.15,
        0.146,
        0.166,
        0.235,
        0.128,
        0.1,
        0.324,
        0.407,
        0.479,
        0.373,
        0.483,
        0.311,
        0.264,
        0.325,
        0.16,
        0.513,
        0.143,
        0.287,
        0.243,
        0.205,
        0.232,
        0.126,
        0.385,
        0.27,
        0.446,
        0.398,
        0.159,
        0.061,
        0.226,
        0.1,
        0.131,
        0.269,
        0.208,
        0.194,
        0.211,
        0.0488,
        0.0492,
        0.1074,
        0.0588,
        0.0646,
        0.0405,
        0.0282,
        0.1118,
        0.2999,
        0.2697,
        0.2457,
        0.169,
        0.2131,
        0.1134,
        0.2079,
        0.1696,
        0.1594,
        0.2288,
        0.2176,
        0.166,
        0.1216,
        0.1984,
        0.1678,
        0.1513,
        0.1738,
        0.1782,
        0.1672,
        0.1791,
        0.0733,
        0.0713,
        0.0833,
        0.1332,
        0.0936,
        0.1187,
        0.0755,
        0.0834,
        0.1166,
        0.1298,
        0.2901,
        0.0928,
        0.2496,
        0.1558,
        0.2674,
        0.1034,
        0.1323,
        0.0974,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.1628,
        0.144,
        0.283,
        0.1943,
        0.179,
        0.1409,
        0.2098,
        0.1774,
        0.1348,
        0.1058,
        0.1336,
        0.1579,
        0.1417,
        0.0817,
        0.0954,
        0.0725,
        0.223,
        0.1376,
        0.1114,
        0.1629,
        0.2899,
        0.1677,
        0.1374,
        0.2318,
        0.2953,
        0.3915,
        0.1277,
        0.4839,
        0.2544,
        0.3131,
        0.4122,
        0.3147,
        0.3573,
        0.1658,
        0.1737,
        0.2356,
        0.0882,
        0.2181,
        0.2556,
        0.1298,
        0.2337,
        0.1718,
        0.1783,
        0.1602,
        0.1582,
        0.1614,
        0.5223,
        0.4793,
        0.4326,
        0.1586,
        0.487,
        0.3629,
        0.2829,
        0.2298,
        0.3934,
        0.2971,
        0.2239,
        0.3548,
        0.3326,
        0.3301,
        0.1968,
        0.1417,
        0.1585,
        0.203,
        0.1503,
        0.4402,
        0.4983,
        0.2513,
        0.0704,
        0.1975,
        0.0829,
        0.3233,
        0.2429,
        0.1563,
        0.2359,
        0.1438,
        0.2473,
        0.4003,
        0.3173,
        0.2232,
        0.2364,
        0.711,
        0.3861,
        0.2216,
        0.2981,
        0.2507,
        0.2613,
        0.2153,
        0.243,
        0.2137,
        0.3298,
        0.2113,
        0.317,
        0.282,
        0.134,
        0.239,
        0.11,
        0.132,
        0.103,
        0.081,
        0.17,
        0.14,
        0.097,
        0.16,
        0.087,
        0.169,
        0.248,
        0.194,
        0.16,
        0.071,
        0.136,
        0.129,
        0.179,
        0.15,
        0.135,
        0.101,
        0.087,
        0.126,
        0.121,
        0.096,
        0.3777,
        0.3224,
        0.6445,
        0.2116,
        0.2451,
        0.2904,
        0.2506,
        0.1472,
        0.139,
        0.268,
        0.2783,
        0.2645,
        0.2297,
        0.2529,
        0.0642,
        0.324,
        0.32,
        0.8899,
        0.2177,
        0.4026,
        0.3674,
        0.2001,
        0.3185,
        0.304,
        0.3101,
        0.148,
        0.1243,
        0.2054,
        0.2967,
        0.218,
        0.1688,
        0.222,
        0.2926,
        0.246,
        0.2776,
        0.377,
        0.272,
        0.37,
        0.028,
        0.159,
        0.126,
        0.2404,
        0.2164,
        0.249,
        0.101,
        0.1134,
        0.2128,
        0.1096,
        0.1875,
        0.2309,
        0.1626,
        0.1392,
        0.1717,
        0.3023,
        0.1957,
        0.1815,
        0.2614,
        0.2295,
        0.2396,
        0.272,
        0.2894,
        0.199,
        0.2534,
        0.2052,
        0.162,
        0.2523,
        0.2998,
        0.2716,
        0.2386,
        0.1941,
        0.157,
        0.1875,
        0.1972,
        0.2396,
        0.2683,
        0.2064,
        0.2338,
        0.1918,
        0.2156,
        0.2169,
        0.1243,
        0.1405,
        0.3011,
        0.1706,
        0.2001,
        0.2116,
        0.1864,
        0.1561,
        0.0966,
        0.2079,
        0.1892,
        0.1351,
        0.1055,
        0.2637,
        0.1343,
        0.1335,
        0.2035,
        0.1763,
        0.1977,
        0.1647,
        0.1195,
        0.0964,
        0.2328,
        0.1101,
        0.1351,
        0.4348,
        0.2856,
        0.2811,
        0.2625,
        0.4715,
        0.2239,
        0.7477,
        0.4971,
        0.5094,
        0.3806,
        0.3793,
        0.4374,
        0.2073,
        0.4027,
        0.1524,
        0.4537,
        0.1653,
        0.3629,
        0.2898,
        0.4144,
        0.1907,
        0.3043,
        0.4239,
        0.1629,
        0.1978,
        0.1866,
        0.3046,
        0.5927,
        0.4588,
        0.2389,
        0.401,
        0.2085,
        0.1673,
        0.5759,
        0.4509,
        0.5082,
        0.453,
        0.1559,
        0.2275,
        0.6494,
        0.5556,
        0.1706,
        0.4304,
        0.292,
        0.2825,
        0.3121,
        0.2215,
        0.1879,
        0.3165,
        0.1657,
        0.1771,
        0.2231,
        0.3673,
        0.3699,
        0.5925,
        0.3409,
        0.4878,
        0.6017,
        0.5824,
        0.3242,
        0.36,
        0.5082,
        0.524,
        0.3862,
        0.6145,
        0.5866,
        0.5298,
        0.5069,
        0.4791,
        0.5706,
        0.6936,
        0.4313,
        0.4046,
        0.5706,
        0.5095,
        0.3194,
        0.6724,
        0.7309,
        0.4864,
        0.3988,
        0.2941,
        0.4157,
        0.1817,
        0.1702,
        0.2359,
        0.2592,
        0.3772,
        0.3523,
        0.2567,
        0.4206,
        0.2365,
        0.3311,
        0.1876,
        0.2369,
        0.2472,
        0.2211,
        0.0433,
        0.0969,
        0.1259,
        0.3089,
        0.239,
        0.1068,
        0.2006,
        0.1867,
        0.2787,
        0.2423,
        0.2343,
        0.215,
        0.2087,
        0.1784,
        0.2297,
        0.1687,
        0.3747,
        0.0646,
        0.2073,
        0.01,
        0.265,
        0.1681,
        0.1113,
        0.1645,
        0.2113,
        0.1291,
        0.1995,
        0.1675,
        0.0677,
        0.1778,
        0.0755,
        0.0863,
        0.1381,
        0.1888,
        0.0969,
        0.0959,
        0.1548,
        0.2539,
        0.2151,
        0.1897,
        0.172,
        0.205,
        0.0905,
        0.0939,
        0.1591,
        0.1657,
        0.1713,
        0.2108,
        0.1002,
        0.151,
        0.171,
        0.1022,
        0.1882,
        0.1628,
        0.1687,
        0.1571,
        0.121,
        0.0515,
        0.1267,
        0.17,
        0.0556,
        0.1231,
        0.1422,
        0.0727,
        0.1256,
        0.15,
        0.1582,
        0.219,
        0.1069,
        0.1509,
        0.118,
        0.0569,
        0.3275,
        0.3473,
        0.2704,
        0.229,
        0.3783,
        0.242,
        0.1923,
        0.1392,
        0.1337,
        0.1223,
        0.1573,
        0.0459,
        0.1178,
        0.1549,
        0.2086,
        0.1525,
        0.1514,
        0.0969,
        0.1578,
        0.1361,
        0.3251,
        0.209,
        0.2138,
        0.1599,
        0.1689,
        0.198,
        0.1994,
        0.2034,
        0.1241,
        0.2051,
        0.1687,
        0.1233,
        0.1525,
        0.2006,
        0.1629,
        0.1055,
        0.266,
        0.281,
        0.1123,
        0.1071,
        0.0917,
        0.1078,
        0.0777,
        0.3285,
        0.1655,
        0.1378,
        0.2136,
        0.1258,
        0.2605,
        0.1006,
        0.063,
        0.3598,
        0.2895,
        0.315,
        0.2064,
        0.2239,
        0.2437,
        0.309,
        0.5044,
        0.5258,
        0.3164,
        0.2099,
        0.268,
        0.2223,
        0.2211,
        0.5481,
        0.2507,
        0.1627,
        0.1459,
        0.1929,
        0.462,
        0.5002,
        0.3105,
        0.2077,
        0.1999,
        0.1738,
        0.1976,
        0.1749,
        0.3373,
        0.3423,
        0.2237,
        0.2012,
        0.2839,
        0.0747,
        0.3142,
        0.2255,
        0.2359,
        0.1972,
        0.0094,
        0.2381,
        0.1918,
        0.1365,
        0.1488,
        0.229,
        0.0642,
        0.1429,
        0.1552,
        0.2158,
        0.2813,
        0.1017,
        0.1243,
        0.1477,
        0.1157,
        0.1761,
        0.1564,
        0.1081,
        0.2241,
        0.1661,
        0.0644,
        0.1396,
        0.1463,
        0.1603,
        0.0805,
        0.4361,
        0.2104,
        0.1097,
        0.423,
        0.4973,
        0.2014,
        0.2573,
        0.4547,
        0.3234,
        0.1222,
        0.3824,
        0.2683,
        0.2129,
        0.1754,
        0.1242,
        0.0759,
        0.1714,
        0.2039,
        0.1446,
        0.1188,
        0.1625,
        0.1199,
        0.0785,
        0.1263,
        0.1903,
        0.0657,
        0.2076,
        0.2052,
        0.32,
        0.42,
        0.3281,
        0.1783,
        0.2306,
        0.2985,
        0.1521,
        0.1642,
        0.2187,
        0.2184,
        0.4045,
        0.3733,
        0.2295,
        0.1604,
        0.2816,
        0.2201,
        0.2048,
        0.2153,
        0.1395,
        0.1753,
        0.0738,
        0.2651,
        0.2182,
        0.189,
        0.2017,
        0.2229,
        0.0556,
        0.1586,
        0.1863,
        0.1274,
        0.1056,
        0.1013,
        0.1739,
        0.2464,
        0.1613,
        0.1322,
        0.1186,
        0.0799,
        0.1097,
        0.2573,
        0.276,
        0.1798,
        0.1935,
        0.1733,
        0.0769,
        0.0621,
        0.2178,
        0.0948,
        0.2282,
        0.1517,
        0.1253,
        0.231,
        0.5584,
        0.1568,
        0.4121,
        0.3528,
        0.5744,
        0.4363,
        0.4636,
        0.2164,
        0.344,
        0.4868,
        0.3723,
        0.2311,
        0.2528,
        0.4496,
        0.1028,
        0.2915,
        0.3246,
        0.2036,
        0.257,
        0.3527,
        0.4438,
        0.2354,
        0.4016,
        0.0592,
        0.4027,
        0.3973,
        0.2522,
        0.3036,
        0.6082,
        0.376,
        0.4095,
        0.3466,
        0.4414,
        0.4677,
        0.7059,
        0.3565,
        0.1246,
        0.2762,
        0.5427,
        0.2238,
        0.2271,
        0.3997,
        0.2852,
        0.4672,
        0.4166,
        0.2811,
        0.6406,
        0.4478,
        0.2297,
        0.6496,
        0.3029,
        0.4262,
        0.3167,
        0.2079,
        0.3377,
        0.2571,
        0.4434,
        0.4403,
        0.392,
        0.1402,
        0.168,
        0.2915,
        0.2294,
        0.3138,
        0.3618,
        0.4092,
        0.4436,
        0.1755,
        0.273,
        0.1406,
        0.198,
        0.4107,
        0.3685,
        0.3565,
        0.2601,
        0.2483,
        0.2466,
        0.3253,
        0.2239,
        0.5611,
        0.1885,
        0.4548,
        0.5974,
        0.3946,
        0.3015,
        0.2764,
        0.2341,
        0.5058,
        0.2026,
        0.1279,
        0.2321,
        0.2703,
        0.2281,
        0.2487,
        0.2589,
        0.4728,
        0.2901,
        0.5399,
        0.6821,
        0.2058,
        0.2282,
        0.2361,
        0.41,
        0.471,
        0.3031,
        0.1041,
        0.7478,
        0.2561,
        0.235,
        0.7005,
        0.2647,
        0.8069,
        0.1385,
        0.1465,
        0.0771,
        0.1169,
        0.6502,
        0.1847,
        0.2861,
        0.1,
        0.1513,
        0.2742,
        0.0925,
        0.1866,
        0.1233,
        0.1539,
        0.174,
        0.0924,
        0.2175,
        0.2939,
        0.3594,
        0.6278,
        0.7259,
        0.3986,
        0.3517,
        0.4888,
        0.12,
        0.6827,
        0.4689,
        0.5737,
        0.4361,
        0.2894,
        0.4912,
        0.498,
        0.4333,
        0.3565,
        0.2586,
        0.3144,
        0.225,
        0.3655,
        0.185,
        0.184,
        0.3235,
        0.7626,
        0.4094,
        0.461,
        0.2725,
        0.151,
        0.078,
        0.2327,
        0.225,
        0.368,
        0.254,
        0.557,
        0.51,
        0.155,
        0.103,
        0.163,
        0.194,
        0.112,
        0.247,
        0.239,
        0.419,
        0.253,
        0.412,
        0.542,
        0.333,
        0.254,
        0.213,
        0.144,
        0.329,
        0.096,
        0.412,
        0.156,
        0.075,
        0.238,
        0.109,
        0.239,
        0.131,
        0.169,
        0.236,
        0.151,
        0.022,
        0.344,
        0.157,
        0.069,
        0.042,
        0.265,
        0.423,
        0.383,
        0.48,
        0.253,
        0.209,
        0.293,
        0.223,
        0.16,
        0.23,
        0.237,
        0.267,
        0.347,
        0.232,
        0.23,
        0.199,
        0.234,
        0.267,
        0.279,
        0.278,
        0.18,
        0.17,
        0.269,
        0.21,
        0.002,
        0.209,
        0.152,
        0.1398,
        0.1252,
        0.1331,
        0.1301,
        0.2801,
        0.2621,
        0.4297,
        0.177,
        0.1714,
        0.1479,
        0.1573,
        0.1645,
        0.2478,
        0.214,
        0.193,
        0.2247,
        0.1891,
        0.2166,
        0.2455,
        0.4071,
        0.0931,
        0.0977,
        0.6071,
        0.2774,
        0.273,
        0.5411,
        0.2809,
        0.2167,
        0.2433,
        0.2021,
        0.2192,
        0.3234,
        0.7663,
        0.5234,
        0.4814,
        0.3171,
        0.2275,
        0.464,
        0.3921,
        0.4756,
        0.3854,
        0.3982,
        0.2645,
        0.1828,
        0.3812,
        0.1438,
        0.4408,
        0.2618,
        0.2858,
        0.1953,
        0.119,
        0.2368,
        0.2301,
        0.2782,
        0.1508,
        0.1795,
        0.2002,
        0.1566,
        0.1561,
        0.189,
        0.2666,
        0.25,
        0.203,
        0.1462,
        0.2335,
        0.2282,
        0.1542,
        0.0799,
        0.0893,
        0.1159,
        0.2218,
        0.1864,
        0.2651,
        0.3125,
        0.2249,
        0.1875,
        0.1999,
        0.2795,
        0.1869,
        0.4972,
        0.1395,
        0.2524,
        0.2019,
        0.0817,
        0.1833,
        0.1136,
        0.1751,
        0.0658,
        0.0041,
        0.1279,
        0.1087,
        0.191,
        0.1025,
        0.2808,
        0.2433,
        0.175,
        0.1823,
        0.0404,
        0.1338,
        0.385493,
        0.415187,
        0.238369,
        0.22851,
        0.16474,
        0.1406,
        0.1477,
        0.0488,
        0.057,
        0.0497,
        0.1817,
        0.1538,
        0.115,
        0.2339,
        0.2027,
        0.1927,
        0.1037,
        0.0465,
        0.1407,
        0.078,
        0.18,
        0.0363,
        0.0443,
        0.0637,
        0.1459,
        0.102,
        0.0433,
        0.1193,
        0.0681,
        0.1969,
        0.046,
        0.0354,
        0,
        0.0238,
        0.0043,
        0.0605,
        0.0925,
        0.0926,
        0.0618,
        0.0895,
        0.0764,
        0.0519,
        0.1573,
        0.1541,
        0.0438,
        0.1888,
        0.1313,
        0.123,
        0.1002,
        0.0959,
        0.0741,
        0.0803,
        0.0879,
        0.1753,
        0.1862,
        0.1567,
        0.1102,
        0.2829,
        0.1466,
        0.0763,
        0.1463,
        0.1042,
        0.0617,
        0.0871,
        0.0492,
        0.2288,
        0.1056,
        0.0608,
        0.0255,
        0.2169,
        0.0486,
        0.1135,
        0.1035,
        0.2346,
        0.0866,
        0.1247,
        0.3296,
        0.199,
        0.1385,
        0.185,
        0.1597,
        0.2038,
        0.1125,
        0.0918,
        0.14,
        0.1245,
        0.1359,
        0.0119,
        0.2001,
        0.1998,
        0.0739,
        0.1375,
        0.1397,
        0.0929,
        0.1031,
        0.0795,
        0.0613,
        0.0693,
        0.0834,
        0.0971,
        0.1187,
        0.0431,
        0.0521,
        0.3,
        0.0984,
        0.0952,
        0.1055,
        0.077,
        0.0842,
        0.0938,
        0.1033,
        0.36,
        0.2,
        0.1494,
        0.16,
        0.17,
        0.08,
        0.15,
        0.15,
        0.2533,
        0.11,
        0.09,
        0.08,
        0.31,
        0.14,
        0.2956,
        0.2194,
        0.1375,
        0.227,
        0.1998,
        0.22,
        0.1716,
        0.0212,
        0.1034,
        0.3654,
        0.3183,
        0.2414,
        0.2768,
        0.352,
        0.2347,
        0.3362,
        0.1751,
        0.3602,
        0.1904,
        0.3067,
        0.4099,
        0.2279,
        0.2387,
        0.2972,
        0.2022,
        0.2987,
        0.0011,
        0.1241,
        0.3612,
        0.3963,
        0.4709,
        0.3533,
        0.3515,
        0.219,
        0.258,
        0.2031,
        0.1985,
        0.1792,
        0.1872,
        0.321,
        0.2147,
        0.1947,
        0.1969,
        0.2519,
        0.1028,
        0.2093,
        0.2482,
        0.1011,
        0.1658,
        0.1763,
        0.0763,
        0.1076,
        0.0855,
        0.2917,
        0.3113,
        0.3069,
        0.2822,
        0.7326,
        0.2613,
        0.266,
        0.2191,
        0.2102,
        0.2866,
        0.1716,
        0.1517,
        0.2069,
        0.2222,
        0.1286,
        0.1419,
        0.1811,
        0.2644,
        0.3961,
        0.2838,
        0.149,
        0.2023,
        0.238,
        0.4418,
        0.1881,
        0.2371,
        0.2267,
        0.593,
        0.3528,
        0.345,
        0.3612,
        0.5185,
        0.268,
        0.334,
        0.339,
        0.2319,
        0.203,
        0.2021,
        0.213,
        0.2004,
        0.173,
        0.2997,
        0.309,
        0.1068,
        0.2126,
        0.2307,
        0.2026,
        0.1279,
        0.2624,
        0.2566,
        0.1024,
        0.1668,
        0.2101,
        0.2098,
        0.5941,
        0.5126,
        0.3344,
        0.5303,
        0.4824,
        0.237,
        0.273,
        0.0906,
        0.144,
        0.2399,
        0.134,
        0.2036,
        0.2208,
        0.179,
        0.1197,
        0.0724,
        0.2322,
        0.051,
        0.0459,
        0.4563,
        0.2103,
        0.2202,
        0.3375,
        0.2568,
        0.2104,
        0.2106,
        0.2697,
        0.1625,
        0.2105,
        0.1303,
        0.1896,
        0.3127,
        0.0896,
        0.1807,
        0.1751,
        0.2078,
        0.2057,
        0.3464,
        0.196,
        0.2353,
        0.2818,
        0.2246,
        0.343,
        0.1713,
        0.2798,
        0.2186,
        0.3107,
        0.1156,
        0.1174,
        0.1489,
        0.4713,
        0.4084,
        0.3603,
        0.3202,
        0.2313,
        0.3164,
        0.2645,
        0.232,
        0.2779,
        0.2184,
        0.5195,
        0.0851,
        0.1607,
        0.0597,
        0.2126,
        0.1941,
        0.126,
        0.1916,
        0.2075,
        0.4457,
        0.3975,
        1.2424,
        0.0989,
        0.1529,
        0.0986,
        0.182,
        0.2237,
        0.0676,
        0.3606,
        0.0681,
        0.2097,
        0.3173,
        0.1582,
        0.4573,
        0.0427,
        0.0449,
        0.1321,
        0.2849,
        0.4424,
        0.1656,
        0.2744,
        0.1069,
        0.1042,
        0.1024,
        0.2034,
        0.1302,
        0.2797,
        0.1504,
        0.2386,
        0.256,
        0.1187,
        0.3881,
        0.2171,
        0.2101,
        0.1395,
        0.2905,
        0.1243,
        0.1892,
        0.1889,
        0.3025,
        0.1368,
        0.1597,
        0.1785,
        0.1299,
        0.1138,
        0.3655,
        0.3179,
        0.2107,
        0.1553,
        0.1556,
        0.2241,
        0.0885,
        0.0576,
        0.0284,
        0.1944,
        0.2285,
        0.1965,
        0.1753,
        0.0573,
        0.1329,
        0.0294,
        0.1677,
        0.1388,
        0.1029,
        0.0957,
        0.2617,
        0.3449,
        0.3342,
        0.028,
        0.1682,
        0.1694,
        0.1833,
        0.3304,
        0.1226,
        0.6071,
        0.1093,
        0.3862,
        0.2967,
        0.2649,
        0.2021,
        0,
        0.0403,
        0.3117,
        0.1542,
    ],
    sru_target: [
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.25,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
        0.2,
        0.2,
        0.2,
        0.25,
        0.25,
        0.25,
        0.25,
        0.25,
    ],
    status: [
        'none',
        'carenced',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'none',
        'carenced',
        'none',
        'none',
        'carenced',
        'carenced',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'exempted',
        'exempted',
        'none',
        'exempted',
        'exempted',
        'deficited',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'none',
        'exempted',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'exempted',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'exempted',
        'deficited',
        'carenced',
        'deficited',
        'none',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'none',
        'none',
        'none',
        'none',
        'none',
        'exempted',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'exempted',
        'carenced',
        'exempted',
        'none',
        'exempted',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'none',
        'carenced',
        'none',
        'carenced',
        'none',
        'carenced',
        'carenced',
        'deficited',
        'none',
        'exempted',
        'deficited',
        'none',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'none',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'exempted',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'none',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'exempted',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'exempted',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'exempted',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'exempted',
        'exempted',
        'none',
        'exempted',
        'exempted',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'exempted',
        'exempted',
        'exempted',
        'deficited',
        'deficited',
        'exempted',
        'deficited',
        'carenced',
        'exempted',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'exempted',
        'carenced',
        'deficited',
        'exempted',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'none',
        'none',
        'exempted',
        'none',
        'exempted',
        'exempted',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'exempted',
        'exempted',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'exempted',
        'deficited',
        'deficited',
        'exempted',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'exempted',
        'deficited',
        'deficited',
        'deficited',
        'exempted',
        'exempted',
        'none',
        'deficited',
        'none',
        'deficited',
        'exempted',
        'deficited',
        'exempted',
        'carenced',
        'carenced',
        'none',
        'none',
        'none',
        'exempted',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'exempted',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'none',
        'carenced',
        'none',
        'none',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'exempted',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'exempted',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'none',
        'carenced',
        'deficited',
        'none',
        'deficited',
        'carenced',
        'deficited',
        'none',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'carenced',
        'exempted',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'none',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'exempted',
        'deficited',
        'none',
        'deficited',
        'carenced',
        'carenced',
        'exempted',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'carenced',
        'none',
        'deficited',
        'deficited',
        'exempted',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'deficited',
        'carenced',
        'none',
        'carenced',
        'none',
        'deficited',
        'none',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'none',
        'none',
        'carenced',
        'deficited',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'carenced',
        'deficited',
        'none',
        'none',
        'exempted',
        'exempted',
        'exempted',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'exempted',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'carenced',
        'carenced',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'carenced',
        'carenced',
        'none',
        'none',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'carenced',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'carenced',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'exempted',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'none',
        'exempted',
        'none',
        'deficited',
        'none',
        'none',
        'deficited',
        'none',
        'carenced',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'exempted',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'exempted',
        'exempted',
        'exempted',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'exempted',
        'exempted',
        'carenced',
        'carenced',
        'carenced',
        'none',
        'carenced',
        'none',
        'carenced',
        'none',
        'carenced',
        'exempted',
        'deficited',
        'none',
        'carenced',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'exempted',
        'exempted',
        'exempted',
        'exempted',
        'exempted',
        'exempted',
        'carenced',
        'none',
        'exempted',
        'deficited',
        'exempted',
        'none',
        'exempted',
        'exempted',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'none',
        'none',
        'deficited',
        'none',
        'carenced',
        'exempted',
        'exempted',
        'exempted',
        'exempted',
        'none',
        'none',
        'none',
        'exempted',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'exempted',
        'exempted',
        'exempted',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'exempted',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'exempted',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'exempted',
        'exempted',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'carenced',
        'carenced',
        'none',
        'deficited',
        'carenced',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'carenced',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'none',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'exempted',
        'exempted',
        'none',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'deficited',
        'deficited',
        'carenced',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'carenced',
        'deficited',
        'deficited',
        'none',
        'none',
        'carenced',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'carenced',
        'none',
        'deficited',
        'none',
        'exempted',
        'none',
        'exempted',
        'none',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'exempted',
        'deficited',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'exempted',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'exempted',
        'deficited',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'none',
        'carenced',
        'deficited',
        'none',
        'none',
        'none',
        'carenced',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'carenced',
        'none',
        'deficited',
        'deficited',
        'none',
        'none',
        'carenced',
        'carenced',
        'carenced',
        'none',
        'none',
        'none',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'deficited',
        'carenced',
        'none',
        'deficited',
        'none',
        'deficited',
        'carenced',
        'deficited',
        'exempted',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'none',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'exempted',
        'none',
        'none',
        'none',
        'exempted',
        'none',
        'none',
        'none',
        'carenced',
        'exempted',
        'exempted',
        'exempted',
        'exempted',
        'deficited',
        'deficited',
        'exempted',
        'exempted',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'exempted',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'none',
        'none',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'none',
        'carenced',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'carenced',
        'none',
        'none',
        'carenced',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'carenced',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'deficited',
        'carenced',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'carenced',
        'carenced',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'carenced',
        'none',
        'carenced',
        'carenced',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'none',
        'carenced',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'carenced',
        'deficited',
        'none',
        'exempted',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'carenced',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'none',
        'exempted',
        'none',
        'deficited',
        'exempted',
        'none',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'exempted',
        'deficited',
        'none',
        'exempted',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'exempted',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'none',
        'none',
        'none',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'carenced',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'none',
        'none',
        'deficited',
        'carenced',
        'carenced',
        'none',
        'deficited',
        'none',
        'carenced',
        'none',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'exempted',
        'carenced',
        'deficited',
        'carenced',
        'exempted',
        'deficited',
        'carenced',
        'carenced',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'exempted',
        'carenced',
        'carenced',
        'carenced',
        'exempted',
        'carenced',
        'carenced',
        'deficited',
        'carenced',
        'none',
        'deficited',
        'carenced',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'exempted',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'exempted',
        'none',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'exempted',
        'deficited',
        'deficited',
        'deficited',
        'exempted',
        'deficited',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'exempted',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'exempted',
        'none',
        'none',
        'none',
        'none',
        'none',
        'exempted',
        'none',
        'carenced',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'exempted',
        'deficited',
        'deficited',
        'carenced',
        'carenced',
        'deficited',
        'exempted',
        'carenced',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'carenced',
        'carenced',
        'carenced',
        'none',
        'carenced',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'none',
        'none',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'carenced',
        'none',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'exempted',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'exempted',
        'deficited',
        'deficited',
        'exempted',
        'deficited',
        'exempted',
        'deficited',
        'none',
        'deficited',
        'carenced',
        'none',
        'none',
        'deficited',
        'carenced',
        'none',
        'carenced',
        'carenced',
        'exempted',
        'deficited',
        'none',
        'carenced',
        'deficited',
        'deficited',
        'carenced',
        'deficited',
        'none',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'none',
        'carenced',
        'none',
        'deficited',
        'none',
        'carenced',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'none',
        'deficited',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'none',
        'carenced',
        'deficited',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'none',
        'none',
        'carenced',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'exempted',
        'deficited',
        'none',
        'exempted',
        'none',
        'exempted',
        'exempted',
        'exempted',
        'none',
        'none',
        'deficited',
        'none',
        'deficited',
        'exempted',
        'deficited',
        'deficited',
        'exempted',
        'exempted',
        'deficited',
        'exempted',
        'none',
        'exempted',
        'none',
        'deficited',
        'deficited',
        'carenced',
        'none',
        'deficited',
        'deficited',
        'deficited',
        'none',
        'deficited',
        'exempted',
        'exempted',
        'deficited',
        'exempted',
        'none',
        'none',
        'deficited',
        'deficited',
        'exempted',
        'exempted',
        'exempted',
        'exempted',
        'exempted',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'deficited',
        'exempted',
        'deficited',
        'deficited',
        'carenced',
        'exempted',
        'none',
        'none',
        'none',
        'exempted',
        'deficited',
        'exempted',
        'deficited',
        'none',
        'carenced',
        'none',
        'exempted',
        'none',
        'none',
        'none',
        'deficited',
        'deficited',
        'carenced',
        'none',
        'deficited',
    ],
    price: [
        0,
        46559.19,
        0,
        0,
        0,
        0,
        0,
        14336.81,
        0,
        0,
        0,
        99279.12,
        0,
        0,
        137434.66,
        95384.38,
        0,
        0,
        0,
        7944.22,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        196945.72,
        0,
        0,
        0,
        0,
        8235788.62,
        717647.21,
        440735.56,
        974193.7,
        75841.38,
        35836.34,
        179332.21,
        0,
        0,
        25902.72,
        407470.2,
        245431.28,
        0,
        176588.77,
        204705.55,
        615343.73,
        0,
        1370292.11,
        196172.93,
        38547,
        438458.41,
        106428.84,
        0,
        75696,
        0,
        1755588,
        2080027.8,
        30290.08,
        1602441.12,
        997092.12,
        426416.32,
        0,
        590727.14,
        2034045.82,
        437201.52,
        0,
        385112.32,
        439316.88,
        360760.16,
        170480.38,
        240391.92,
        98727.6,
        1582.82,
        613120.43,
        255964.81,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        58289.88,
        0,
        77742.72,
        202470.08,
        69865,
        0,
        39941.49,
        0,
        0,
        0,
        0,
        447134.09,
        0,
        43424.48,
        129917.58,
        175334.4,
        21752,
        16948.07,
        0,
        0,
        635740.63,
        0,
        0,
        0,
        0,
        117777.2,
        0,
        816965.96,
        0,
        873153.18,
        0,
        1293020.85,
        661653.77,
        0,
        0,
        0,
        0,
        0,
        301967.24,
        582623.5,
        0,
        126841.2,
        210510.74,
        473310.9,
        403968.32,
        417173.12,
        357709,
        373417.52,
        389368.26,
        335378.28,
        82937.76,
        119079.26,
        96859.35,
        0,
        221670.72,
        440325.72,
        378802.8,
        399242.13,
        0,
        91304.96,
        1001984.83,
        0,
        24094.26,
        289900.29,
        243507.28,
        50706.59,
        367980.9,
        263178.9,
        162508.37,
        237442.74,
        5747.86,
        41661.4,
        284092.38,
        256916.1,
        654722.66,
        313522.72,
        319850.9,
        0,
        0,
        217646.72,
        71614.18,
        64107.67,
        69431.8,
        0,
        137176.44,
        0,
        183518.3,
        70728.61,
        0,
        11297.1,
        114316.2,
        0,
        0,
        94899.15,
        0,
        0,
        0,
        0,
        30199.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        186377.24,
        0,
        63176.98,
        0,
        0,
        99628.69,
        58762.89,
        73392.14,
        0,
        92156.22,
        130251.38,
        136229.29,
        0,
        22299.53,
        0,
        119843.49,
        221947.43,
        0,
        0,
        271860.1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        147476.35,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        17413.14,
        0,
        38587.64,
        0,
        87178.18,
        39407.94,
        27718.93,
        0,
        105553.22,
        60513.98,
        108738.21,
        0,
        0,
        2485.26,
        0,
        0,
        0,
        83457,
        29729.02,
        0,
        71337.2,
        38015.25,
        26112.6,
        0,
        0,
        0,
        0,
        0,
        16228.62,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        9596.75,
        0,
        0,
        0,
        185976.51,
        0,
        0,
        147123.59,
        29797.57,
        87438.4,
        153877.43,
        20939.1,
        93210.53,
        0,
        20394.14,
        30648.45,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        19743.3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        18745.44,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        14587,
        0,
        0,
        123553,
        106061,
        0,
        0,
        32897,
        0,
        35573,
        0,
        43900,
        52170,
        0,
        0,
        0,
        7038,
        0,
        0,
        17382,
        0,
        92273,
        0,
        0,
        0,
        139427,
        0,
        0,
        113698,
        140586,
        3167,
        0,
        234346,
        140045,
        44017,
        215699,
        67069,
        105645,
        126142,
        42724,
        57228,
        59137,
        88595,
        115159.7476,
        36741.7979,
        0,
        46179.8771,
        44560.5449,
        57663.1,
        0,
        0,
        23423.0468,
        0,
        15082.5829,
        7235.5031,
        13010.7777,
        0,
        0,
        45779.7777,
        0,
        0,
        0,
        12007.1575,
        168054.0257,
        40255.4339,
        0,
        0,
        30782.7801,
        16077.7817,
        69184.2,
        24669.2732,
        0,
        0,
        22114.4376,
        0,
        35297.486,
        0,
        32613.8521,
        7492.1483,
        8294.8691,
        25417.7942,
        0,
        0,
        4742.65,
        0,
        0,
        0,
        0,
        221650.07,
        43092.7341,
        13483.6137,
        97125.8447,
        0,
        0,
        63042,
        0,
        35630,
        0,
        0,
        0,
        0,
        0,
        40554,
        0,
        0,
        0,
        0,
        0,
        171109,
        0,
        0,
        0,
        0,
        66769,
        6231,
        84339,
        1853,
        0,
        0,
        121871,
        221713,
        66989,
        867469,
        722932,
        51894,
        55412,
        191644,
        81518,
        35681,
        55983,
        107070,
        41419,
        153932,
        64181,
        53923,
        85883,
        46963,
        0,
        10529,
        10830,
        23399,
        70986,
        104575,
        487468,
        0,
        0,
        109921,
        161261,
        339624,
        233922,
        62296,
        113503,
        174194,
        0,
        212231,
        693884,
        227870,
        178961,
        93021,
        164952,
        126772,
        60951,
        73465,
        65129,
        307175,
        137641,
        98423,
        47920,
        0,
        198656,
        36007,
        275105,
        142862,
        0,
        0,
        194588,
        0,
        29398,
        0,
        105921,
        0,
        71774,
        0,
        0,
        704138,
        0,
        124314,
        175203,
        50261,
        70122,
        0,
        49101.31,
        22283.89,
        0,
        0,
        0,
        0,
        0,
        0,
        29093.72,
        47203.08,
        0,
        0,
        0,
        10529.08,
        0,
        17919.55,
        0,
        0,
        0,
        0,
        16796.4,
        0,
        0,
        78286.18,
        12444.12,
        0,
        0,
        0,
        0,
        34176.56,
        0,
        0,
        6856.38,
        0,
        0,
        32412.66,
        57336.68,
        35916.45,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        39758.3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        54561.45,
        0,
        0,
        0,
        6270.04,
        7284.29,
        23665.54,
        25705.38,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        27933.08,
        0,
        0,
        0,
        0,
        0,
        0,
        69438,
        0,
        97707,
        27688,
        0,
        0,
        37675,
        121285,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        78356,
        0,
        0,
        0,
        0,
        28436,
        0,
        0,
        0,
        0,
        0,
        0,
        2557.2,
        0,
        0,
        0,
        58113.42,
        126831.76,
        0,
        112670.36,
        0,
        83236.24,
        0,
        0,
        0,
        318389.88,
        0,
        497923.47,
        131293.78,
        316671.78,
        233991.24,
        0,
        0,
        0,
        296788.13,
        63416.19,
        99829.07,
        10170.14,
        100748.66,
        39818.47,
        0,
        0,
        0,
        13410.59,
        224768.5,
        230088.7,
        1281819.19,
        0,
        0,
        253231.07,
        0,
        124615.94,
        0,
        672403.5,
        0,
        111838.24,
        0,
        0,
        0,
        48420.21,
        0,
        0,
        0,
        0,
        0,
        0,
        62563.27,
        14462.14,
        58074.87,
        0,
        82981.33,
        4491.3,
        0,
        0,
        37408.29,
        0,
        0,
        0,
        44011.57,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        30614.28,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        45669.7,
        0,
        0,
        0,
        0,
        22639.08,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        53089.58,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        24143.38,
        0,
        23170,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        50710,
        0,
        113773,
        0,
        134688,
        74795,
        0,
        32466,
        0,
        0,
        0,
        11089,
        0,
        0,
        0,
        149217,
        68785,
        82647,
        0,
        14539,
        0,
        0,
        14179,
        26520,
        0,
        25963,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        31944.64,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        29708.85,
        56140,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        50453.91,
        0,
        0,
        32216.39,
        0,
        0,
        15629.97,
        28421.45,
        0,
        0,
        314334.79,
        192100.65,
        0,
        0,
        103326.48,
        0,
        0,
        84238.05,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        45307.13,
        0,
        0,
        112086.46,
        0,
        0,
        0,
        13999.63,
        12625.15,
        0,
        0,
        63452.16,
        41535.04,
        0,
        30397.55,
        0,
        0,
        65978.99,
        36489.6,
        75114.91,
        0,
        19938.35,
        0,
        0,
        0,
        0,
        0,
        0,
        28558.84,
        0,
        0,
        87609,
        0,
        0,
        27504.25,
        16542.37,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        19620.56,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        15460.48,
        0,
        10294.7,
        0,
        0,
        0,
        0,
        0,
        0,
        44516.25,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        27808.2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        10413.36,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        7211.76,
        0,
        0,
        0,
        277526,
        0,
        30989.97,
        0,
        0,
        326988,
        0,
        11069,
        0,
        0,
        0,
        0,
        0,
        24958,
        0,
        3570,
        0,
        0,
        0,
        0,
        0,
        571400.96,
        2576969.19,
        314480.87,
        54666.38,
        289082.5,
        52432.84,
        39421.26,
        277958.82,
        97984.29,
        96645.79,
        117855,
        133754.28,
        0,
        197142.26,
        142055.12,
        0,
        0,
        0,
        0,
        0,
        0,
        76763.84,
        0,
        0,
        17338.26,
        0,
        0,
        81087.44,
        31719.97,
        87679.52,
        0,
        72947.88,
        72504.26,
        53118.84,
        75901.51,
        146539.19,
        249846.24,
        98456.19,
        43491.88,
        0,
        101633.4,
        34592.51,
        0,
        0,
        86432.09,
        0,
        0,
        95845.06,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        130716.72,
        222531.91,
        63607.1,
        185576.01,
        83047.79,
        175664.34,
        165821.72,
        155256.55,
        39829.32,
        90799.02,
        165816.42,
        136638.56,
        85338.18,
        52333.56,
        0,
        0,
        0,
        87698.66,
        0,
        0,
        0,
        0,
        88612.39,
        0,
        0,
        0,
        0,
        0,
        17920.66,
        40822.1,
        0,
        0,
        0,
        158939.89,
        0,
        0,
        63366.23,
        0,
        0,
        10540.23,
        0,
        0,
        0,
        17379.17,
        55271.07,
        0,
        0,
        0,
        0,
        16932.33,
        0,
        0,
        0,
        0,
        0,
        290704.82,
        0,
        0,
        0,
        0,
        0,
        682391.08,
        779703.09,
        688709.22,
        0,
        0,
        0,
        37877.55,
        221886.04,
        59365,
        0,
        143892.45,
        0,
        0,
        0,
        252836.5,
        0,
        71545.46,
        0,
        0,
        16173.42,
        8965.55,
        0,
        0,
        57510.72,
        196831.83,
        0,
        13570.02,
        251965.5,
        62875.26,
        171449.7,
        24007.73,
        0,
        0,
        1277062.59,
        153766.58,
        0,
        51750.86,
        72552.86,
        0,
        54142.63955,
        86237.88,
        0,
        174993.67,
        35831.25,
        56613.94,
        394871.52,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        40281.08,
        0,
        0,
        0,
        0,
        0,
        33006.83,
        0,
        0,
        30170.8,
        33141.78,
        379533.94,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        45387.49,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        50463,
        73461.72,
        0,
        142032,
        0,
        43314.4,
        62437.2,
        47265.12,
        0,
        0,
        0,
        0,
        257493.44,
        208589.24,
        44009.02,
        0,
        0,
        25501.7,
        108875.87,
        36576.28,
        135704.06,
        41755.24,
        0,
        0,
        0,
        27912.96,
        138610.68,
        81529.05,
        0,
        18630.85,
        79530.66,
        30261.67,
        179923.26,
        60358.65,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        5483200.09,
        0,
        0,
        1321826.92,
        0,
        0,
        0,
        0,
        0,
        191574.27,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        623040.03,
        1189823.55,
        0,
        0,
        0,
        0,
        0,
        0,
        1659838.3,
        0,
        0,
        490356.1,
        0,
        0,
        0,
        0,
        9732.91,
        0,
        0,
        85897.84,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        674489.65,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        68259.56,
        48816.35,
        0,
        0,
        0,
        917238.38,
        0,
        0,
        33627.38,
        0,
        0,
        0,
        248863.12,
        429460.52,
        715720.79,
        0,
        0,
        0,
        0,
        132602.04,
        0,
        0,
        153936.48,
        32807.4,
        78332.73,
        48435.53,
        69166.94,
        40868.97,
        12881.22,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        145890.35,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        7375.36,
        14123.72,
        0,
        0,
        0,
        0,
        0,
        16229.52,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        31493.6,
        72306.33,
        21221.19,
        134718.17,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        76804.97,
        0,
        0,
        0,
        55320.33,
        72966.87,
        0,
        58228.45,
        5549.06,
        0,
        0,
        27068.45,
        165034.91,
        139571.36,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        32772.02,
        0,
        10488.36,
        31984.3,
        5174.12,
        0,
        0,
        0,
        75124.32,
        0,
        82604.22,
        0,
        0,
        0,
        0,
        58166.05,
        19526.22,
        0,
        6287.82,
        0,
        0,
        0,
        0,
        243722.54,
        328750.13,
        0,
        0,
        0,
        0,
        0,
        18697.29,
        0,
        0,
        0,
        5074.5,
        133182.4,
        234826.24,
        52131.52,
        25806.9,
        24388.44,
        6642.79,
        0,
        33542.04,
        75096.2,
        0,
        0,
        0,
        0,
        0,
        0,
        23762.4,
        87884.16,
        46135.76,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        120262.45,
        0,
        162378.74,
        0,
        0,
        0,
        57186.3,
        160835.64,
        9326.2,
        20395.46,
        0,
        93369.6,
        44970.8,
        29420.2,
        48319.89,
        50317.44,
        30450.24,
        0,
        0,
        19751,
        24642.64,
        0,
        160511.6,
        176183.7,
        9571.33,
        0,
        0,
        1094316.7,
        555682.72,
        0,
        0,
        0,
        0,
        217840.77,
        0,
        51410,
        0,
        289542.4,
        0,
        0,
        16688,
        0,
        0,
        0,
        139150.49,
        46065.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        19314.29,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        53769.58,
        0,
        0,
        0,
        0,
        56037.32,
        20484.45,
        26291.52,
        0,
        47329.92,
        120532.38,
        486082.66,
        740314.29,
        434515.54,
        1330152.81,
        255650.2,
        319749.19,
        126614.04,
        0,
        274744.98,
        137503.8,
        0,
        0,
        95739.79,
        883550.19,
        233524.08,
        269066.15,
        779708.72,
        0,
        225083.48,
        0,
        0,
        0,
        62052.41,
        148557.9,
        110846.57,
        199255.45,
        188093.21,
        299251.5,
        155611.34,
        0,
        2965709.58,
        1152520.5,
        318531.75,
        1622965.26,
        0,
        0,
        821140.39,
        94020.67,
        0,
        724076.8,
        124447.92,
        101552.32,
        0,
        126628.17,
        32426.59,
        0,
        0,
        146120.67,
        77734.94,
        86259.2,
        0,
        0,
        0,
        0,
        154295.36,
        298845,
        62411.97,
        89942.52,
        51496.2,
        368772,
        179602,
        74348.32,
        80666,
        43394.2,
        179747,
        0,
        76386.13,
        454329.44,
        64926.9,
        398469.24,
        0,
        0,
        0,
        0,
        0,
        0,
        655173.16,
        278095.41,
        0,
        0,
        0,
        0,
        0,
        93593.17,
        0,
        66063.38,
        0,
        60690.96,
        0,
        0,
        0,
        15746.41,
        0,
        59866.73,
        26564.9,
        32060.52,
        0,
        0,
        40366.56,
        5990.49,
        0,
        0,
        0,
        0,
        64774.33,
        0,
        0,
        0,
        16421.37,
        75376.04,
        45396.45,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        49562.4,
        0,
        0,
        0,
        0,
        0,
        111899.04,
        0,
        122994,
        64341.76,
        91834.8,
        360014.73,
        0,
        0,
        89076.67,
        9184.95,
        0,
        0,
        8837.57,
        0,
        171288.7,
        90510.22,
        0,
        0,
        43239.93,
        22000.96,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        27071,
        34430.04,
        0,
        72473.66,
        66935.68,
        24041.58,
        14117.5,
        60076.65,
        0,
        0,
        0,
        0,
        0,
        1509305.85,
        0,
        0,
        0,
        139575.19,
        12998.23,
        19377.64,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        32203.2,
        0,
        72863.04,
        0,
        61090.5,
        330092.7,
        0,
        0,
        262400.44,
        37021.6,
        22263.44,
        34876.48,
        154866.24,
        0,
        0,
        0,
        0,
        12164.7,
        7134.14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        196433.98,
        0,
        119859.6,
        0,
        0,
        44154.86,
        157608,
        0,
        10085.33,
        0,
        67867.05,
        0,
        0,
        142157.11,
        0,
        0,
        0,
        0,
        0,
        704921.36,
        87325.14,
        0,
        48007.78,
        0,
        135149.98,
        0,
        22213.1,
        0,
        0,
        0,
        103393.44,
        0,
        0,
        0,
        0,
        278313.6,
        0,
        53551.25,
        0,
        260443.88,
        0,
        30297.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        15625.61,
        0,
        18462.02,
        0,
        355154.49,
        14451.06,
        56188.45,
        78636.49,
        44475.9,
        0,
        27741.87,
        19443.48,
        0,
        0,
        0,
        747458.46,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        63790.54,
        0,
        0,
        44031.17,
        0,
        0,
        0,
        0,
        0,
        43832.88,
        280395.58,
        0,
        63218.65,
        22626.24,
        38024.62,
        0,
        66994.88,
        0,
        0,
        40019.9,
        0,
        0,
        0,
        115378.56,
        113385.6,
        0,
        0,
        0,
        0,
        0,
        0,
        154833.94,
        211178.99,
        0,
        0,
        97437.99,
        0,
        399848.72,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        349259.9,
        0,
        0,
        0,
        0,
        0,
        97534.97,
        0,
        154500.22,
        0,
        61416.79,
    ]
}



export const get_sru = (inseecode) => {
    var result_data = {
        nb_log: null,
        sru_current: null,
        sru_target: null,
        exempted: null,
        status: null,
        price: null,
    }

    // Check validity
    if (inseecode === null || inseecode === undefined) {
        return result_data
    }

    // Check arrondissements
    if (inseecode.indexOf("751") === 0) { // PARIS
        inseecode = "75056";
    }
    if (inseecode.indexOf("6938") === 0) { // LYON
        inseecode = "69123";
    }
    if (inseecode.indexOf("132") === 0) { // MARSEILLE
        inseecode = "13055";
    }
    // Get index
    var index = sru_data.code.indexOf(inseecode);

    if (index > -1) {
        result_data.nb_log = sru_data.nb_log[index];
        result_data.sru_current = sru_data.sru_current[index];
        result_data.sru_target = sru_data.sru_target[index];
        // result_data.exempted = sru_data.exempted[index];
        result_data.status = sru_data.status[index];
        result_data.price = sru_data.price[index];
    }

    return result_data
}